
const kshetraTranslation = {
    Dakshin: "दक्षिण",
    DakshinMadhya: "दक्षिण मध्य",
    Paschim: "पश्चिम", 
    Madhya: "मध्य",
    UttarPaschim: "उत्तर पश्चिम",
    Uttar: "उत्तर",
    PaschimUP: "पश्चिम उत्तर प्रदेश",
    PurvUP: "पूर्व उत्तर प्रदेश", 
    UttarPurv: "उत्तर पूर्व",
    Purv: "पूर्व",
    Assam: "असम",   
}

const PrantTranslation = {
    UttarKerala: "उत्तर केरल",
    DakshinKerala: "दक्षिण केरल",
    DakshinTamilnadu: "दक्षिण तमिलनाडु",
    UttarTamilnadu: "उत्तर तमिलनाडु",
    KarnatakUttar: "कर्नाटका उत्तर",
    KarnatakaDakshin: "कर्नाटका दक्षिण",
    Andhra: "आंध्र",
    Telengana: "तेलंगाना",
    Konkan: "कोकण",
    PaschimMaharashtra: "पश्चिम महाराष्ट्र",
    Devgiri: "देवगिरी",
    Saurashtra: "सौराष्ट्र",
    Gujarat: "गुजरात",
    Vidarbh: "विदर्भ",
    Malwa: "मालवा",
    MadhyaBharat: "मध्य भारत",
    Mahakoshal: "महाकोशल",
    Chattisgarh: "छत्तीसगढ़",
    Jaipur: "जयपुर",
    Jodhpur: "जोधपुर",
    Chittod: "चित्तौड़",
    Delhi: "दिल्ली",
    Punjab: "पंजाब",
    Haryana: "हरियाणा",
    JammuKashimir: "जम्मू कश्मीर",
    Himanchal: "हिमाचल",
    Uttarakhand: "उत्तराखंड",
    Meerut: "मेरठ",
    Brij: "बृज",
    Kanpur: "कानपुर",
    Awadh: "अवध",
    Kashi: "काशी",
    Goraksh: "गोरक्ष",
    UttarBihar: "उत्तर बिहार",
    DakshinBihar: "दक्षिण बिहार",
    Jharakhand: "झारखंड",
    OdisaPaschim: "ओडिशा पश्चिम",
    OdishaPurv: "ओडिशा पूर्व",
    DakshinBang: "दक्षिण बंगाल",
    MadhyaBang: "मध्य बंगाल",
    UttarBang: "उत्तर बंगाल",
    DakshinAssam: "दक्षिण असम",
    Manipur: "मणिपुर",
    UttarAssam: "उत्तर असम",
    Arunachal: "अरुणाचल",
    Tripura: "त्रिपुरा",

}

const VibhagTranslation = {
    THIRUVANANTHAPURAM: "तिरुवनंतपुरम",
    KOLLAM: "कोल्लम",
    SABARIGIRI: "सबरीगिरी",
    KOTTAYAM: "कोट्टायम",
    ERNAKULAM: "एर्नाकुलम",
    IDUKKI: "इडुक्की",
    THRISSUR: "त्रिशूर",
    PALAKKAD: "पलक्कड़",
    MALAPPURAM: "मलप्पुरम",
    KOZHIKODE: "कोझिकोड",
    KANNUR: "कन्नूर",
    Kanyakumari: "कन्याकुमारी",
    Madurai: "मदुरै",
    Rameshwaram: "रामेश्वरम",
    Tanjavur: "तंजावुर",
    Tiruchy: "तिरुची",
    Tirpur: "तिरपुर",
    Koimbtoor: "कोयंबटूर",
    ERODE: "एरोड",
    SALEM: "सलेम",
    VELLORE: "वेल्लोर",
    PUDUCHERRY: "पुडुचेरी",
    KANCHI :"कांची",
    CHENNAI: "चेन्नई",  
    sirsi: "सिर्सी",  
    dharawad: "धारवाड़",  
    belagavi: "बेलगावी",  
    vijaypur: "विजयपुर",  
    kalaburagi: "कलबुर्गी",  
    Bellari: "बेल्लारी",  
    Mysuru: "मैसूरु",  
    Hasan: "हसन",  
    Mangluru: "मंगलुरु",  
    Shivmogga: "शिवमोग्गा",  
    Tumkur: "तुमकुर",  
    Kolar: "कोलार",  
    BengaluruUttar: "बेंगलुरु उत्तर",  
    BengaluruDakshin: "बेंगलुरु दक्षिण",  
    VIZIANAGARAM: "विजयनगरम",  
    VISAKHA: "विशाखा",  
    GODAVARI: "गोदावरी",  
    VIJAYAWADA: "विजयवाड़ा",  
    GUNTUR: "गुंटूर",  
    NELLORE: "नेल्लोर",  
    TIRUPATI: "तिरुपति",  
    ANANTAPUR: "अनंतपुर",  
    KURNOOL: "कुरनूल",  
    Palamur: "पलामुर",  
    Medek: "मेडक",  
    Indur: "इंदूर",  
    Karinagar: "करिनगर",  
    Warangal: "वारंगल",  
    Khammam: "खम्मम",  
    Nalgonda: "नलगोंडा",  
    Secunderabad: "सेकुंदराबाद",  
    Bhayganagar: "भयंगनगर",  
    Parel: "परेल",  
    Ghatkopar: "घाटकोपर",  
    Parle: "पारले",  
    Goregaon: "गोरेगांव",  
    Thane: "ठाणे",  
    Kalyan: "कल्याण",  
    Raygadh: "रायगढ़",  
    Ratnagiri: "रत्नागिरी",  
    Goa: "गोवा",  
    Kolhapur: "कोल्हापुर",  
    Pune: "पुणे",  
    Nashik: "नाशिक",  
    PuneMahanagar: "पुणे महानगर",  
    Jalgaon: "जलगांव",  
    Sambhajinagar: "सांभाजी नगर",  
    Nanded: "नांदेड",  
    Latur: "लातुर",  
    Kachha: "कच्चा",  
    Rajkot: "राजकोट",  
    Junagadha: "जुनागढ़",  
    Bhavnagar: "भावनगर",  
    Surendranagar: "सुरेंद्रनगर",  
    Navsari: "नवसारी",  
    Vadodra: "वडोदरा",  
    Nadiyad: "नदीयाद",  
    Gandhinagar: "गांधीनगर",  
    Mehsana: "मेहसाणा",  
    Banaskatha: "बनासकथा",  
    Surat: "सूरत",  
    KarnawatiPurva: "कर्णावती पूर्व",  
    KarnawatiPaschim: "कर्णावती पश्चिम",  
    Buldhana: "बुलढाणा",  
    Akola: "अकोला",  
    Amrawati: "अमरावती",  
    Yawatmal: "यवतमाल",  
    Chandarapur: "चंद्रपुर",  
    Ramtek: "रामटेक",  
    Nagpur: "नागपुर",  
    Dewas: "देवास",  
    Ujjain: "उज्जैन",  
    Mandasur: "मंदसौर",  
    Ratlam: "रतलाम",  
    Dhar: "धार",  
    Indore: "इंदौर",  
    Khargone: "खरगोन",  
    Khandwa: "खंडवा",  
    Muraina: "मुरैना",  
    Gwaliar: "ग्वालियर",  
    Shivapuri: "शिवपुरी",  
    Guna: "गुना",  
    Rajgadh: "राजगढ़",  
    Vidisha: "विदिशा",  
    Bhopal: "भोपाल",  
    Narmadapur: "नर्मदापुर",  
    Chhattarpur: "छतरपुर",  
    Satana: "सतना",  
    Riva: "रीवा",  
    Sagar: "सागर",  
    Jabalapur: "जबलपुर",  
    Shahadol: "शहडोल",  
    Mandala: "मंडला",  
    Chhindawada: "छिंदवाड़ा",  
    Koria: "कोरिया",  
    Sarguja: "सरगुजा",  
    Raigadh: "रायगढ़",  
    Koraba: "कोराबा",  
    Bilasapur: "बिलासपुर",  
    Raipur: "रायपुर",  
    Rajim: "राजिम",  
    Durg: "दुर्ग",  
    Rajnandgaon: "राजनंदगांव",  
    UttarBastar: "उत्तर बस्तर",  
    MadhyaBastar: "मध्य बस्तर",  
    DakshinBastar: "दक्षिण बस्तर",  
    Jhunjhunu: "झुंझुनू",  
    Sikar: "सीकर",  
    Alwar: "अलवर",  
    Bharatpur: "भरतपुर",  
    SawaiMadhopur: "सवाई माधोपुर",  
    Sanganer: "सांगानेर",  
    Jaipur: "जयपुर",  
    Pali: "पाली",  
    Jalor: "जालोर",  
    Badmer: "बाडमेर",  
    Jodhpur: "जोधपुर",  
    Nagaur: "नागौर",  
    Bikaner: "बीकानेर",  
    ShreeGanganagar: "श्री गंगानगर",  
    Banswada: "बांसवाड़ा",  
    Udaipur: "उदयपुर",  
    Rajsamand: "राजसमंद",  
    Chittod: "चित्तौड़",  
    Bhilwada: "भीलवाड़ा",  
    Ajaymeru: "अजयमेरू",  
    Kota: "कोटा",  
    Bara: "बारा",  
    Yamunavihar: "यमुनाविहार",  
    Poorwi: "पूर्वी",  
    Dakshin: "दक्षिण",  
    Ramkrushnapuram: "रामकृष्णपुरम",  
    Pashchimi: "पश्चिमी",  
    Keshavpuram: "केशवपुरम",  
    Uttarivibhag: "उत्तरि विभाग",  
    Jhandewala: "झंडेवाला",  
    Ludhiyana: "लुधियाना",  
    Chandigarh: "चंडीगढ़",  
    Patiala: "पटियाला",  
    Bathinda: "बठिंडा" ,   
    Firozpur: "फिरोजपुर",
    Amritsar: "अमृतसर",
    Pathankot: "पठानकोट",
    Jalandhar: "जालंधर",
    Ambala: "अंबाला",
    Kurukshetra: "कुरुक्षेत्र",
    Rohtak: "रोहतक",
    Faridabad: "फरीदाबाद",
    Gurugram: "गुरुग्राम",
    Bhivani: "भिवानी",
    Hissar: "हिसार",
    Kathua: "कटुआ",
    Jammu: "जम्मू",
    Rajouri: "राजौरी",
    Udhampur: "उधमपुर",
    Dooda: "दूदा",
    Chamba: "चंबा",
    Kangada: "कांगड़ा",
    Bilaspur: "बिलासपुर",
    Mand: "मंडी",
    Rampur: "रामपुर",
    Shimla: "शिमला",
    Solen: "सोलन",
    Deharadun: "देहरादून",
    Haridwar: "हरिद्वार",
    Tihari: "टिहरी",
    Paudi: "पौड़ी",
    Chamauli: "चमौली",
    Pithoragad: "पिथौरागढ़",
    Almoda: "अल्मोड़ा",
    Nainital: "नैनीताल",
    BIJNOR: "बिजनोर",
    Bulandshahar: "बुलंदशहर",
    Gaziabad: "गाज़ियाबाद",
    LAXMINAGAR: "लक्ष्मीनगर",
    MEERUT: "मेरठ",
    MORADABAD: "मुरादाबाद",
    NOIDA: "नोएडा",
    SAHARANPUR: "सहारनपुर",
    SAMBHAL: "सांभल",
    Agra: "आगरा",
    Chandranagar: "चंद्रनगर",
    Shahipur: "शाहपुर",
    Bareli: "बरेली",
    Badayaun: "बदायूं",
    Aita: "आइता",
    Harigarh :"हरीगढ़",
    Mathura: "मथुरा",
    Jhansi: "झांसी",
    ChitrakootDham: "चित्रकूट धाम",
    Phatehpur: "फतेहपुर",
    Kanpur: "कानपुर",
    Pharukhabad: "फर्रुखाबाद",
    Itavaa: "इटावा",
    Lucknow: "लखनऊ",
    Raibareli: "रायबरेली",
    Ulaw: "उलव",
    Sitapur: "सीतापुर",
    Gonda: "गोंडा",
    Baharich: "बहरिच",
    Saket: "साकेत",
    Kashi: "काशी",
    Sonbhadra: "सोनभद्र",
    Vindhyachal: "विन्ध्याचल",
    Prayagraj: "प्रयागराज",
    Pratapgarh: "प्रतापगढ़",
    Sultanpur: "सुलतानपुर",
    Jaunpur: "जौनपुर",
    Basti: "बस्ती",
    SiddharthNagar: "सिद्धार्थ नगर",
    Gorakhapur: "गोरखपुर",
    Devariya: "देवरिया",
    Baliya: "बिलिया",
    Aryamgadh: "आर्यंगढ़",
    Champaran: "चंपारण",
    Saran: "सारण",
    Muzafarpur: "मुजफ्फरपुर",
    Sitamadhi: "सीतामढ़ी",
    Darbhanga: "दरभंगा",
    Begusaray: "बेगूसराय",
    Koshi: "कोशी",
    Purniya: "पूर्णिया",
    Katiyahar: "कटिहार",
    Bhojapur: "भोजपुर",
    Rohatas: "रोहतास",
    Gaya: "गया",
    Danapur: "दानापुर",
    Nalanda: "नालंदा",
    Munger: "मुंगेर",
    Bhagalpur: "भागलपुर",
    Jamashedpur: "जमशेदपुर",
    Ranchi: "रांची",
    Gumala: "गुमला",
    Palamu: "पलामू",
    Hajaribaug: "हजारीबाग",
    Dhanabad: "धनबाद",
    Devaghar: "देवघर",
    Sahebganj: "साहेबगंज",
    Koraput: "कोरापुट",
    Kalahandi: "कालाहांडी",
    Bolagir: "बलांगीर",
    Sambalpur: "संबलपुर",
    Raurkela: "राउरकेला",
    Puri: "पुरी",
    Cuttak: "कटक",
    Balaore: "बालेश्वर",
    Mayurbhan: "मयूरभंज",
    Dhenkanal: "धेनकनाल",
    Ganjam: "गंजाम",
    Midnapur: "मिदनापुर",
    Tamrolipt: "तम्रोलिप्त",
    Uttar24Paragana: "उत्तर 24 परगना",
    Dakshin24Paragana: "दक्षिण 24 परगना",
    AndamanandNicobar: "अंडमान और निकोबार",
    HowrahMahanagar: "हावड़ा महानगर",
    KolakataUttar: "कोलकाता उत्तर",
    KolakataPurv: "कोलकाता पूर्व",
    Kolakatadakshinpoorw: "कोलकाता दक्षिण पूर्व",
    Kolakatadakshinpashchim: "कोलकाता दक्षिण पश्चिम",
    KolkataUttar: "कोलकाता उत्तर",
    KolkataDakshinPashchim: "कोलकाता दक्षिण पश्चिम",
    KolkataDakshinPoorw: "कोलकाता दक्षिण पूर्व",
    Mandi: "मंडी",
    Nadiya: "नदिया",
    Birbhum: "बीरभूम",
    Vardhaman: "वर्धमान",
    Bankura: "बांकुरा",
    Hugali: "हुगली",
    CoochBihar: "कूच बिहार",
    Siligudi: "सिलीगुड़ी",
    Sikkkim: "सिक्किम",
    Dinajpur: "दिनाजपुर",
    Malda: "मालदा",
    Shilchar: "शिलचर",
    Karmkunj: "कर्मकुंज",
    Haflang: "हाफलांग",
    Thoubal: "थौबाल",
    Imphal: "इंफाल",
    Bishnupur: "बिष्णुपुर",
    Senapati: "सेनापति",
    Dibrugadh: "डिब्रूगढ़",
    Joraghat: "जोरहाट",
    Lakhmipur: "लखमीर",
    Tejpur: "तेजपुर",
    Nagon: "नागोन",
    Difu: "डिफू",
    Guwahati: "गुवाहाटी",
    Nalbari: "नलबाड़ी",
    Dhubri: "धुबरी",
    Shilong: "शिलॉन्ग",
    Tura: "तुरा",
    Kohima: "कोहिमा",
    EastArunachalPradesh: "पूर्व अरुणाचल प्रदेश",
    Siang: "सियांग",
    Subasnasari: "सुबासनसारी",
    Kameng: "कामेंग",
    DharmNagar: "धर्मनगर",
    Agartala: "अगरतला",
    KolkataPurv: "कोलकाता पूर्व",
}


const JilaTranslation = {
    ATTINGAL: "अत्तिंगल",
   NEDUMANGAD: "नेदुमंगद",
   THIRUVANANTHAPURAM_GRAMAM: "तिरुवनंतपुरम ग्रामम",
   THIRUVANANTHAPURAM_MAHANAGAR: "तिरुवनंतपुरम महानगर",
   KOLLAM_GRAMAM: "कोल्लम ग्रामम",
   KOLLAM_MAHANAGAR: "कोल्लम महानगर",
   PUNALUR: "पुनालुर",
   ALAPPUZHA: "अलप्पुझा",
   CHENGANNUR: "चेंगन्नुर",
   PATHANAMTHITTA: "पथनमथिट्टा",
   SABARIGIRI: "सबरिगिरी",
   KOTTAYAM: "कोट्टायम",
   PONKUNNAM: "पोंकुन्नम",
   VAIKOM: "वैकोम",
   ALUVA: "अलुवा",
   DEVIKULAM: "देविकुलम",
   IDUKKI: "इडुक्की",
   THODUPUZHA: "थोडुपुझा",
   KOCHI_MAHANAGAR: "कोच्चि महानगर",
   MOOVATTUPUZHA: "मूवत्तुपुझा",
   CHALAKKUDI: "चालक्कुडी",
   GURUVAYUR: "गुरुवायुर",
   IRINJALAKKUDA: "इरिंजलक्कुडा",
   THRISSIVAPEROOR: "त्रिस्सिवापेरूर",
   KOLLANKODE: "कोल्लांकोडे",
   OTTAPPALAM: "ओट्टापलम",
   PALAKKAD: "पालक्काड",
   MALAPPURAM: "मलप्पुरम",
   TIRUR: "तिरुर",
   KOZHIKODE_GRAMAM: "कोझिकोड ग्रामम",
   KOZHIKODE_MAHANAGAR: "कोझिकोड महानगर",
   VADAKARA: "वाडाकारा",
   WAYANAD: "वायनाड",
   KANHANGAD: "कन्हांगड",
   KANNUR: "कन्नूर",
   KASARGOD: "कासरगोड",
   PAYYANNUR: "पय्यन्नूर",
   KUMARI_W: "कुमारी (पश्चिम)",
   KUMARI_E: "कुमारी (पूर्व)",
   Tenkasi: "तेनकासी",
   Tirunelveli: "तिरुनेलवेली",
   Tiruchendur: "तिरुचेंदुर",
   Thoothukkudi: "थूथुकुडी",
   Virudunagar: "विरुधुनगर",
   Madurai: "मदुरै",
   Theni: "थेनी",
   Dindukkal: "दिंडुक्कल",
   MADURAI_MAHANAGAR: "मदुरै महानगर",
   RAMANATHAPURAM: "रामनाथपुरम",
   Sivagangai: "सिवगंगाई",
   Aranthangi: "अरंथंगी",
   Pudukkottai: "पुडुकोट्टाई",
   NAGAPATTINAM: "नागपट्टिनम",
   TIRUVARUR: "तिरुवरूर",
   PATTUKKOTTAI: "पट्टुकोट्टाई",
   TANJAVUR: "तंजावुर",
   Ariyalur: "आरीयालुर",
   Perambalur: "पेरम्बलुर",
   Tiruchy: "तिरुचि",
   Karur: "करूर",
   Dharapuram: "धारापुरम",
   Tiruppur: "तिरुप्पुर",
   Nilagiri: "निलगिरी",
   METPALAYAM: "मेट-पलयम",
   Pollachi: "पोलाची",
   Kovai: "कोवई",
   GOBICHETTIPALAYAM: "गोबिचेट्टिपलयम",
   ERODE: "एरोड",
   NAMAKKAL: "नमक्कल",
   ATTUR: "अत्तुर",
   SALEM: "सलेम",
   DHARMAPURI: "धर्मपुरी",
   KRISHNAGIRI: "कृष्णागिरी",
   THIRUPPATTUR: "थिरुप्पट्टुर",
   VELLORE: "वेल्लोर",
   VANDAVASI: "वंदावसी",
   TIRUVANNAMALAI: "तिरुवन्नमलै",
   KALLAKURICHI: "कल्लाकुरिची",
   CUDDALORE: "कुडालोर",
   PONDY: "पॉण्डी",
   VILLUPURAM: "विल्लुपुरम",
   CHENGALPATTU: "चेंगलपट्टू",
   KANCHIPURAM: "कांचीपुरम",
   RANIPETTAI: "रानीपेट्टई",
   THIRUVALLUR: "तिरुवल्लुर",
   THIRUVOTTIYUR_BHAG: "तिरुवोत्तियूर भाग",
   PERAMBUR: "पेराम्बुर",
   AMBATTUR: "अम्बत्तूर",
   VADAPALANI: "वडापलानी",
   MAMBALAM: "मंबालम",
   MEDAVAKKAM: "मेदवाक्कम",
   TAMBARAM: "ताम्बराम",
   Sirasi: "सिरासी",
   Karawar	: "करवार",
   dandeli: "दंडेली",
   HUBBALLIMAHANAGAR: "हुब्बल्ली महानगर",
   dharawad: "धारवाड़",
   gadag: "गदग",
   haveri: "हावेरी",
   belagavi: "बेळगावी",
   chikkodi: "चिक्कोडी",
   vijayapur: "विजयापुर",
   bagalakote: "बागलकोटे",
   jamakhandi: "जमखंडी",
   kalaburagi: "कलबुर्गी",
   yadagiri: "यादगीरी",
   bidar: "बीडर",
   ballari: "बल्लारी",
   vijaynagar: "विजयनगर",
   raichur: "रायचूर",
   koppala: "कोप्पल",
   MysuruMahanagar: "मैसूरू महानगर",
   MysuruGramantar: "मैसूरू ग्रामंतर",
   Chamrajnagar: "चामराजनगर",
   Mandya: "मंड्या",
   Hasan: "हसन",
   Arsikere: "अर्सिकेरे",
   Chikkamangluru: "चिक्कमंगलुरु",
   Shringeri: "श्रिंगेरी",
   MangluruMahanagar: "मंगलुरू महानगर",
   MangluruGramantar: "मंगलुरू ग्रामंतर",
   Udupi: "उदुपी",
   Puttur: "पुत्तुर",
   Kodgu: "कोडगु",
   Shivmogga: "शिवमोग्गा",
   Sagar: "सागर",
   Dawangere: "दावंगरे",
   Chitradurg: "चित्रदुर्ग",
   Tumkur: "तुमकुर",
   Tiptur: "तिप्तूर",
   Madhugiri: "मधुगिरी",
   Ramnagar: "रामनगर",
   Kolar: "कोलार",
   Chikkaballapur: "चिक्काबल्लापुर",
   BengaluruGramantar: "बेंगलुरु ग्रामंतर",
   Dasrhalli: "दशरली",
   Yalhank: "यालहांक",
   Krishnarajpur: "कृष्णराजपुर",
   Halsuru: "हल्सुरु",
   Hebbal: "हेब्बल",
   Malleshwar: "मल्लेश्वर",
   Basveshwar: "बसवेश्वर",
   Vijaynagar: "विजयनगर",
   Shankarpur: "शंकरपुर",
   Banshnkri: "बंशनकी",
   Jaynagar: "जयनगर",
   Chandapur: "चांदापुर",
   Vartur: "वर्तुर",
   Marthalli: "मार्थल्ली",
   SRIKAKULAM: "स्रीकाकुलम",
   MANYAM: "मण्याम",
   VIZIANAGARAM: "विजयनागारम",
   ALLURI: "अल्लूरी",
   VISHAKAMAHANAGAR: "विशाखा महानगर",
   ANAKAPALLI: "आनकपल्ली",
   KAKINADA: "काकीनाडा",
   EASTGODAVARI: "पूर्वी गोदावरी",
   KONASEEMA: "कोनसीमा",
   WESTGODAVARI: "पश्चिमी गोदावरी",
   ELURU: "एलुरु",
   KRISHNA: "कृष्णा",
   VIJAYAWADAMAHANAGAR: "विजयवाड़ा महानगर",
   GUNTUR: "गुंटूर",
   BAPATLA: "बापटला",
   PALNADU: "पालनाडु",
   PRAKASAM: "प्रकाशम",
   NELLORE: "नेल्लोर",
   TIRUPATI: "तिरुपति",
   CHITTOOR: "चित्तूर",
   ANNAMAYYA: "अन्नामय्या",
   SRISATYASAI: "स्री सत्यसाई",
   ANANTAPUR: "अनंतपुर",
   KADAPA: "कदापा",
   NANDYAL: "नांदायल",
   KURNOOL: "कुर्नूल",
   Vanparti: "वांपार्टी",
   NagarKarnool: "नगर कर्नूल",
   Palmur: "पल्मूर",
   Anantgiri: "अनंतगिरी",
   SangaReddy: "संगा रेड्डी",
   Medak: "मेदक",
   Siddhpet: "सिद्धपेट",
   Kamareddy: "कामारेड्डी",
   Indur: "इंदुर",
   Nirmal: "निर्मल",
   Adilabad: "आदिलाबाद",
   Manchiryal: "मंचिरयाल",
   Peddhapalli: "पेड्डापल्ली",
   Jagtiyal: "जगतियाल",
   Karinagar: "करीनगर",
   Bhupalpalli: "भूपलपल्ली",   
   WarangalGramin: "वारंगल ग्रामीन",
   WarangalMahanagar: "वारंगल महानगर",
   Jangam: "जंगम",
   Manukota: "मनुकोटा",
   Khammam: "खम्मम",
   Bhadradikottagudem: "भद्रादि कोट्टागुडे",
   Suryapet: "सूर्यपेट",
   Nalgonda: "नलगोंडा",
   Bhuvangiri: "भुवंगीरी",
   UppalBhag: "उप्पल भाग",
   MalkajigiriBhag: "मलकाजिगिरी भाग",
   SecunderabadBhag: "सेकुंदराबाद भाग",
   BoeinpalliBhag: "बोइंपाल्ली भाग",
   KuktpalliBhag: "कुकटपल्ली भाग",
   GolkondaBhag: "गोलकोंडा भाग",
   CharminarBhag: "चारमीनार भाग",
   MmaheshwaramJIla: "महेश्वरम जिला",
   DilkhushnagarBhag: "दिलखुशनगर भाग",
   BarkatpuraBhag: "बारकतपुरा भाग",
   Mumbadevi: "मुंबादेवी",
   Siddhivinayak: "सिद्धिविनायक",
   Chembur: "चेम्बूर",
   Ghatkopar: "घाटकोपर",
   Mulund: "मुलुंड",
   Kurla: "कुर्ला",
   Vidyapeeth: "विद्यापीठ",
   Sahaar: "सहार",
   Oshivra: "ओशिवरा",
   Dindoshi: "दिंदोशी",
   Marve: "मरवे",
   Borivali: "बोरिवली",
   NaviMumbi: "नवी मुंबई",
   Thane: "ठाणे",
   Bhaindar: "भायंदर",
   Wasai: "वसई",
   Palghar: "पालघर",
   Bhivanidi: "भिवंडी",
   Kalyan: "कल्याण",
   Ambarnath: "अंबरनाथ",
   Kulaba: "कुलाबा",
   Raygadh: "रायगढ़",
   UttarRatnagiri: "उत्तर रत्नागिरी",
   DakshinRatnagiri: "दक्षिण रत्नागिरी",
   Sindhudurg: "सिंधुदुर्ग",
   UttarGoa: "उत्तर गोआ",
   DakshinGoa: "दक्षिण गोआ",
   DKolhapur: "द. कोल्हापूर",
   UKohlapur: "उ. कोल्हापूर",
   Sangali: "सांगली",
   Karad: "कराड",
   Satara: "सातारा",
   Solapur: "सोलापुर",
   Pandharpur: "पंढरपूर",
   Baramati: "बारामती",
   PuneGramin: "पुणे ग्रामीन",
   PimpriChinchawad: "पिंपरी चिंचवाड़",
   DakshinNagar: "दक्षिण नगर",
   UttarNagar: "उत्तर नगर",
   Malegaon: "मालेगांव",
   NashikGramin: "नाशिक ग्रामीण",
   NashikMahanagar: "नाशिक महानगर",
   Kasba: "कस्बा",
   Sambhaji: "सांभाजी",
   Singhgadh: "सिंहगढ़",
   Parwati: "पार्वती",
   Katraj: "कटराज",
   Hadapsar: "हडपसर",
   Wadgavsheri: "वडगावशेरी",
   Yervada: "येरवड़ा",
   Vidyapeetin: "विद्यापीठिन",
   Jalgaon: "जलगांव",
   Bhusaval: "भुसावल",
   Dhule: "धुले",
   Nandurbar: "नंदुरबार",
   SambhajinagarShahar: "सांभाजी नगर शहर",
   SambhajinagarGramin: "सांभाजी नगर ग्रामीण",
   Jalana: "जलना",
   Parabhani: "परभणी",
   Nanded: "नांदेड",
   Kinvat: "किनवट",
   Hingoli: "हिंगोली",
   Latur: "लातूर",
   Dharashiv: "धराशिव",
   PoorvaBeed: "पूर्व बीड",
   PashchimBeed: "पश्चिम बीड",
   KachhaPurva: "कच्चा पूर्व",
   KachhaPashim: "कच्चा पश्चिम",
   Jamanagar: "जामनगर",
   Morabee: "मोरबी",
   Gondal: "गोंडल",
   RajkotMahanagar: "राजकोट महानगर",
   Porbandar: "पोर्बंदर",
   Somnath: "सोमनाथ",
   Junagadha: "जूनागढ़",
   Sawarkundala: "सावरकुंडला",
   Amarelee: "अमरली",
   Bhavnagar: "भावनगर",
   Dhandhuka: "धंधुका",
   Viramgram: "वीरामग्राम",
   Surendranagar: "सुरेन्द्रनगर",
   Valsad: "वलसाड",
   Navsari: "नवसारी",
   Vyara: "वयारा",
   SuratGramya: "सूरत ग्रामीण",
   Bharuch: "भरूच",
   ChotaUadipur: "छोटा उदीपुर",
   Narmada: "नर्मदा",
   VadodraGramya: "वडोदरा ग्रामीण",
   Vadodra: "वडोदरा",
   Dahod: "दाहोद",
   Panchmahal: "पंचमहल",
   Mahisagar: "महिसागर",
   Anand: "आनंद",
   Kheda: "खेडा",
   Gandhinagar: "गांधीनगर",
   Sabarkantha: "साबरकांठा",
   Arvalli: "अरवल्ली",
   Visnagar: "विशनगर",
   Mehsana: "मेहसाणा",
   Patan: "पाटन",
   Radhanpur: "राधनपुर",
   Palanpur: "पालनपुर",
   Disa: "दीसा",
   Tharad: "थारद",
   Ambika: "अंबिका",
   Rander: "रांदेर",   
   Udhna: "उधना",
   Shivaji: "शिवाजी",
   Sarthana: "सार्थना",
   Varcha: "वर्चा",
   Katargam: "कटारगाम",
   Godadra: "गोडद्रा",
   Maninagar: "मणिनगर",
   Amraiwadi: "अम्राईवाडी",
   Bapunagar: "बापुनगर",
   Asarawa: "आसरावा",
   Naroda: "नरोदा",
   Vatwa: "वाटवा",
   Paaldi: "पालदी",
   Memnagar: "मेमनगर",
   Bopal: "बोपल",
   Naranpura: "नारानपुरा",
   Chandlodiya: "चांदलोदिया",
   Sabarmati: "साबरमती",
   Buldhana: "बुलढाणा",
   Khamgaon: "खामगांव",
   AkolaMahanagar: "अकोला महानगर",
   Washim: "वाशिम",
   AmrawatiMahanagar: "अमरावती महानगर",
   Achalpur: "अचलपुर",
   Wardha: "वर्धा",
   Yawatmal: "यवतमाल",
   Pusad: "पुसद",
   Pandharkwada: "पंढरकवड़ा",
   Chandrapur: "चंद्रपुर",
   Aheri: "अहेरी",
   Gadchiroli: "गडचिरोली",
   Brhampuri: "ब्रह्मपुरी",
   Ramtek: "रामटेक",
   Katol: "काटोल",
   Umred: "उमरेड",
   AJANI: "अजनि",
   AYODHYA: "अयोध्या",
   BINAKI: "बिनाकी",
   DHARAMPETH: "धर्मपेठ",
   GITTIKHADAN: "गिट्टीखदान",
   ITWARI: "इतवारी",
   LALGANJ: "लालगंज",
   MOHITE: "मोहिते",
   NANDANVAN: "नंदनवन",
   SADAR: "सदर",
   SOMALWADA: "सोमलवाड़ा",
   TRIMURTI: "त्रिमूर्ति",
   Shajapur: "शाजापुर",
   Dewas: "देवास",
   Kannod: "कन्नोद",
   Agar: "आगर",
   UjjainGramin: "उज्जैन ग्रामीण",
   Nagda: "नगदा",
   UjjainMahanagar: "उज्जैन महानगर",
   Nimach: "निमाच",
   Garoth: "गरोठ",
   Mandsaur: "मंदसौर",
   Jawar: "जावर",
   Ratlam: "रतलाम",
   Jhabua: "झाबुआ",
   Dhar: "धार",
   Kukshi: "कुक्शी",
   Alirajpur: "आलिराजपुर",
   Dwarika: "द्वारिका",
   Badrinath: "बद्रीनाथ",
   Jagannath: "जगन्नाथ",
   Rameshwarm: "रामेश्वरम",
   Mhow: "महू",
   Badwani: "बड़वानी",
   Sendhwa: "सेंधवा",
   Khargone: "खरगोन",
   Badwah: "बदवह",
   Omkareshwar: "ओंकारेश्वर",
   Khandwa: "खंडवा",
   Brhampur: "ब्रह्मपुर",
   Muraina: "मुरैना",
   Bhid: "भीड",
   Lahar: "लहार",
   Datiya: "दतिया",
   Dabara: "दाबरा",
   Gwaliar: "ग्वालियर",
   Lashkar: "लश्कर",
   Shyopur: "श्योपुर",
   Shivapuri: "शिवपुरी",
   Pichchor: "पिछोर",
   AshokNagar: "आशोक नगर",
   Guna: "गुना",
   Raghogadh: "रघोगढ़",   
   Rajgadh: "राजगढ़",
   Byabara: "ब्याबरा",
   Seehor: "सीहोर",
   Budani: "बुदानी",
   Vidisha: "विदिशा",
   Vasauda: "वासौदा",
   Raysen: "रेसिन",
   Bareli: "बरेली",
   Tope: "टोपी",
   Vidyut: "विद्युत",
   Vikram: "विक्रम",
   Pratap: "प्रताप",
   Bhaujpur: "भौजपुर",
   Narmadapur: "नर्मदापुर",
   Pipariya: "पिपरिया",
   Harada: "हरदा",
   Baitul: "बैतूल",
   Mulatai: "मुलताई",
   Tikamagadh: "टिकमगढ़",
   Chhattarpur: "छतरपुर",
   Lavkushnagar: "लवकुश नगर",
   Panna: "पन्ना",
   Katani: "कटनी",
   Maihar: "मैहर",
   Satana: "सताना",
   Riva: "रीवा",
   Mauganj: "मौगंज",
   Sidhi: "सिधी",
   Sigarauli: "सिगरौली",
   Beena: "बीना",
   Damoh: "दमोह",
   Narasinhpur: "नरसिंहपुर",
   JabalapurJila: "जबलपुर जिला",
   JabalapurMahanagar: "जबलपुर महानगर",
   Umariya: "उमरिया",
   Shahadol: "शहडोल",
   Anupapur: "अनुपपुर",
   Dindori: "दिंदोरी",
   Mandala: "मंडला",
   Bichhiya: "बिछिया",
   Balaghat: "बालाघाट",
   Baihar: "बिहार",
   Sivani: "सिवानी",
   Lakhanadaun: "लखनादौन",
   Chhindawada: "छिंदवाड़ा",
   Parasiya: "परसिया",
   Koria: "कोरिया",
   Surajpur: "सुरजपुर",
   Ambikapur: "अंबिकापुर",
   Balarampur: "बलरामपुर",
   Kansabel: "कांसेबल",
   Jashapur: "जशपुर",
   Raigadh: "रायगढ़",
   Sarangadh: "सरंगढ़",
   Koraba: "कोरबा",
   Sakti: "सक्ति",
   Janjagir: "जांजगीर",
   Bilasapur: "बिलासपुर",
   Mungeli: "मुगेली",
   Pendara: "पेंदरा",
   RaipurMahanagar: "रायपुर महानगर",
   RaipurGramin: "रायपुर ग्रामीण",
   Balaudabajar: "बलौदाबाजार",
   Mahasamund: "महासमुंद",
   Gariyaband: "गरियाबंद",
   Dhamatari: "धमतरी",
   Durg: "दुर्ग",
   Bemetara: "बेमेतरा",
   Kabirdham: "कबीरधाम",
   Rajnandgaon: "राजनांदगांव",
   Balaud: "बलौद",
   AmbagadhChowki: "अंबागढ़ चौकी",
   Kankar: "कांकर",
   Bhanupratappur: "भानुप्रतापपुर",
   Narayanpur: "नारायणपुर",
   Jagadalpur: "जगदलपुर",
   Kondagaon: "कोंडागांव",
   Dantewada: "दंतेवाड़ा",
   Sukma: "सुकमा",
   Bijapur: "बीजापुर",
   Chidawa: "चिड़ावा",
   Jhunjhunu: "झुंझुनू",
   Churu: "चुरू",
   Ratangarh: "रतनगढ़",
   Sikar: "सीकर",
   ShreeMadhopur: "श्री माधोपुर",
   Kotputli: "कोटपुतली",
   Bhiwadi: "भीवाड़ी",
   Alwar: "अलवर",
   Deeg: "दीग",
   Bharatpur: "भारतपुर",
   Dhaulpur: "धौलपुर",
   Karoli: "करौली",
   Dausa: "दौसा",
   SawaiMadhopur: "सवाई माधोपुर",
   Tonk: "टोंक",
   SanganerGramin: "सांगनेर ग्रामीण",
   SanganerMahanagar: "सांगनेर महानगर",
   Sambhar: "सांभर",
   Bassi: "बसी",
   Rishigalav: "ऋषिगलाव",
   Malviya: "मलविया",
   Mansarowar: "मंसारोवर",
   Vidyadhar: "विद्याधर",
   Pali: "पाली",
   Bali: "बाली",
   Sojat: "सोजत",
   Jalaur: "जालौर",
   Bheenman: "भीनमण",
   Sirohi: "सिरोही",
   Badmer: "बाड़मेर",
   Balotara: "बालोतरा",   
   Jaisalmer: "जैसलमेर",
   JodhpurMahanagar: "जोधपुर महानगर",
   Jodhpur: "जोधपुर",
   Phalodi: "फलोदी",
   Nagaur: "नागौर",
   Medta: "मेडता",
   Deedwana: "दीवद्वाना",
   BikanerMahanagar: "बीकानेर महानगर",
   Nokha: "नोखा",
   Khajuwala: "खाजुवाला",
   ShreeGanganagar: "श्री गंगानगर",
   Hanumangarh: "हनुमानगढ़",
   Suratgarh: "सूरतगढ़",
   Banswara: "बांसवाड़ा",
   Sagwara: "सागवाड़ा",
   Dungarpur: "दूंगरपुर",
   UdaipurMaha: "उदयपुर महा",
   UdaipurJila: "उदयपुर जिला",
   slumber: "स्लम्बर",
   Rajsamand: "राजसमंद",
   Amet: "अमेट",
   bheendar: "भींडर",
   Chittor: "चित्तौड़",
   nimbaaheda: "निम्माबेहड़ा",
   Pratapgarh: "प्रतापगढ़",
   BhilwaraMaha: "भीलवाड़ा महा",
   Bhilwara: "भीलवाड़ा",
   Asind: "आसिंद",
   Shahpura: "शाहपुरा",
   AjaymeruMaha: "अजमेरू महा",
   Ajaymeru: "अजमेरू",
   Beawar: "बेवाड़",
   KotaMahanagar: "कोटा महानगर",
   KotaJila: "कोटा जिला",
   Ramganjmandi: "रामगंजमंडी",
   Boondi: "बूंदी",
   Baran: "बारां",
   ChhipaBaroda: "छीपा बारोड़ा",
   Jhalwad: "झालवाड",
   BhawaniMandi: "भवानी मंडी",
   Karaval: "करावल",
   Brahmapuri: "ब्रह्मपुरी",
   Nandnagri: "नंदनगरि",
   Rohatash: "रोहटाश",
   Shahadara: "शाहदारा",
   GandhiNagar: "गांधी नगर",
   Indraprasth: "इंद्रप्रस्थ",
   MayurVihar: "मयूर विहार",
   Lajapat: "लाजपत",
   Badarapur: "बदरापुर",
   Kalakaji: "कालकाजी",
   Ambedkar: "अम्बेडकर",
   Mihiravali: "मिहीरावली",
   Vasant: "वसंत",
   Dwaraka: "द्वारका",
   Nahargadh: "नाहरगढ़",
   Uttam: "उत्तम",
   Nangaloi: "नंगलोई",
   Tilak: "तिलक",
   Janakpuri: "जनकपुरी",
   motinagar: "मोटीनगर",
   SaraswatiNagar: "सरस्वती नगर",
   Rohini: "रोहिणी",
   Kanjhavala: "कांझावाला",
   Narela: "नरेला",
   buradi: "बुराड़ी",
   MukhrjeeNagar: "मुखर्जी नगर",
   KamalaNagar: "कमला नगर",
   KaraulBaug: "करावल बाग",
   PatelNagar: "पटेल नगर",
   Sarabha: "सराभा",
   Sukhdev: "सुखदेव",
   Vishavkarma: "विश्वकर्मा",
   Khanna: "खन्ना",
   Jagraon: "जगराओं",
   Chandigarh: "चंडीगढ़",
   Mohali: "मोहाली",
   FatehgarhSahib: "फतेहगढ़ साहिब",
   RoopNagar: "रूप नगर",
   Patiala: "पटियाला",
   Sangrur: "संगरूर",
   Barnala: "बरनाला",
   Bathinda: "बठिंडा",
   Muktsar: "मुख्तसर",
   Faridkot: "फरीदकोट",
   Mansa: "मानसा",
   Ferozpur: "फिरोजपुर",
   Moga: "मोगा",
   Fazilka: "फाजिल्का",
   Amritsar: "अमृतसर",
   Batala: "बटाला",
   Tarantarn: "तरनतारण",
   Pathankot: "पठानकोट",
   Mukeriyan: "मुखेरियां",
   Hoshiarpur: "होशियारपुर",
   Gurdaspur: "गुरदासपुर",
   Jalandhar: "जालंधर",
   ShaheedBhagatSinghNagar: "शहीद भगत सिंह नगर",
   Phagwara: "फगवाड़ा",
   Kapurthala: "कपूरथला",
   Panchkula: "पंचकुला",
   Ambala: "अम्बाला",
   Yamunanagar: "यमुनानगर",
   Jagadhari: "जगाधरी",
   Kurukshetra: "कुरुक्षेत्र",
   Kaidhal: "कैथल",
   karnal: "करनाल",
   Panipat: "पानीपत",
   Rohtak: "रोहतक",
   Jeed: "जीद",
   Zujjar: "जुज्जर",
   Soneepat: "सोनीपत",
   FaridabadPurva: "फरीदाबाद पूर्व",
   FaridabadPaschim: "फरीदाबाद पश्चिम",
   Ballbhgad: "बलभगढ़",
   Palval: "पलवल",
   Gurugram: "गुरुग्राम",
   Manesar: "मानेसर",
   Nooh: "नूह",
   Bhivani: "भिवानी",
   Revadee: "रेवाड़ी",
   Dadree: "दादरी",
   Mahendragadh: "महेंद्रगढ़",
   Hissar: "हिसार",
   Hansee: "हांसी",
   Fatehabad: "फतेहाबाद",
   Sirsa: "सिरसा",
   Kathua: "कटुआ",
   Basholi: "बशोली",
   Billawar: "बिलावर",
   Saba: "सबा",
   RanveersinghPura: "रणवीर सिंह पुरा",
   JammuMahanagar: "जम्मू महानगर",
   Nagarota: "नागरोटा",
   Akhnoor: "अखनूर",
   Sundarbani: "सुंदरबनी",
   Rajouri: "राजौरी",
   Poonch: "पुंछ",
   Reasi: "रेसी",
   Udhampur: "उधमपुर",
   Ramban: "रामबन",
   Dooda: "दूदा",
   Chamba: "चंबा",
   Teesa: "टीसा",
   Nurpur: "नूरपुर",
   Kangada: "कांगड़ा",
   Palampur: "पालमपुर",
   Jofindranagar: "जॉफिंड्रानगर",
   Dehra: "देहरा",
   Bilaspur: "बिलासपुर",   
   Hamirpur: "हमीरपुर",
   Una: "ऊना",
   Sarkaghat: "सरकाघाट",
   Sundarnagar: "सुंदरनगर",
   Banjar: "बांजार",
   Kullu: "कुल्लू",
   Rampur: "रामपुर",
   Kinnor: "किन्नौर",
   Kasog: "कासोग",
   Shimla: "शिमला",
   Mhasu: "महासू",
   Rohdu: "रोहडू",
   dadlaghat: "ददलगाट",
   Solen: "सोलन",
   Nalagadh: "नलगढ़",
   Haripudhar: "हरीपुरधार",
   Sirmor: "सिरमौर",
   DeharadunUttar: "देहरादून उत्तर",
   DeharadunDakshin: "देहरादून दक्षिण",
   VikasNagar: "विकास नगर",
   Purola: "पुरोला",
   Hrishikesh: "ऋषिकेश",
   Haridwar: "हरिद्वार",
   Ruraki: "रुरकी",
   Tihari: "टिहरी",
   UttarKashi: "उत्तरकाशी",
   DewPrayag: "देवप्रयाग",
   Paudi: "पौड़ी",
   Thalisain: "थलिसैन",
   Kotdwar: "कोटद्वार",
   Chamauli: "चमौली",
   Karnprayag: "कर्णप्रयाग",
   RudraPrayag: "रुद्र प्रयाग",
   Pithoragad: "पिथोरागढ़",
   Didihat: "डिडिहाट",
   Champavat: "चम्पावत",
   Almoda: "अल्मोड़ा",
   Ranikhet: "रानीखेत",
   Bageshwar: "बागेश्वर",
   Nainital: "नैनीताल",
   Halvaani: "हल्द्वानी",
   UdhamsinhNagar: "उधमसिंह नगर",
   Kashipur: "काशीपुर",
   BIJNOR: "बिजनोर",
   DHAMPUR: "धामपुर",
   Bulandshahar: "बुलंदशहर",
   Khurja: "खुर्जा",
   AnuppurShahar: "अनुपपुर शहर",
   GaziabadMahanagar: "गाजियाबाद महानगर",
   VaishaliMahanagar: "वैशाली महानगर",
   HarnandiMahanagar: "हर्नांडी महानगर",
   GaziabadJila: "गाजियाबाद जिला",
   BAGPAT: "बागपत",
   LAXMINAGAR: "लक्ष्मी नगर",
   SHAMLI: "शामली",
   HAPUR: "हापुड़",
   MAWANA: "मवाना",
   MEERUT: "मेरठ",
   SARDHANA: "सढ़ाना",
   MORADABAD: "मुरादाबाद",
   RAMPUR: "रामपुर",
   THAKURDWARA: "ठाकुरद्वारा",
   NoidaMahanagar: "नोएडा महानगर",
   GoutambuddhNagar: "गौतमबुद्ध नगर",
   BEHAT: "बेहट",
   DEVVRIND: "देववृन्द",
   SAHARANPUR: "सहारनपुर",
   AMROHA: "अमरोहा",
   BABARALA: "बबराला",
   SAMBHAL: "साम्भाल",
   AgraPaschimMahanagar: "आगरा पश्चिम महानगर",
   AgraPurvMahanagar: "आगरा पूर्व महानगर",
   AgraChawaniMahanagar: "आगरा छावनी महानगर",
   Rambag: "रामबाग",
   FatehpurSikri: "फतेहपुर सीकरी",
   ChandraNagar: "चंद्र नगर",
   Tundla: "टुंडला",
   Shikohabad: "शिकोहाबाद",
   Mainpuri: "मैनपुरी",
   ShajipurMahanagar: "शाहजीपुर महानगर",
   Puvanyun: "पुवान्युन (शाहजीपुर ग्रामीण)",
   Parshurampuri: "पारशुरामपुरी (जालालाबाद)",
   Pilibhit: "पीलीभीत",
   Bisalpur: "बिसलपुर",
   BareliMahanagar: "बरेली महानगर",
   Bhedi: "भेदी",
   Awala: "आवला",
   Badaiyu: "बदायू",
   Sahaswan: "सहसवान",
   Aita: "ऐता",
   Kasgan: "कसगान",
   HarigarhMahanagar: "हैरीगढ़ महानगर",
   Khair: "खैर",
   Atroli: "अटरोली",
   Hathras: "हाथरस",
   MathuraMahanagar: "मथुरा महानगर",
   Vrindavan: "वृंदावन",
   Kosi: "कोसी",
   JhansiMahanagar: "झांसी महानगर",
   Lalitpur: "ललितपुर",
   JhansiJila: "झांसी जिला",
   UraiJila: "उरई जिला",
   Chitrkut: "चित्रकूट",
   Banda: "बांदा",
   Mahoba: "महोबा",
   Phatehpur: "फतेहपुर",
   Khaga: "खागा",
   Chhatampur: "छटंपुर",
   KanpurUttar: "कानपुर उत्तर",
   KanpurPoorva: "कानपुर पूर्व",
   KanpurDakshin: "कानपुर दक्षिण",
   KanpurPashchim: "कानपुर पश्चिम",
   Pharukhabad: "फरुखाबाद",
   Kanauj: "कानौज",
   Bilhaur: "बिल्हौर",
   Itava: "इटावा",
   Aureya: "औरैया",
   KanpurDehat: "कानपुर देहात",
   LucknowPoorva: "लखनऊ पूर्व",
   LucknowPashchim: "लखनऊ पश्चिम",
   LucknowUttar: "लखनऊ उत्तर",
   LucknowDakshin: "लखनऊ दक्षिण",
   LucknowGramin: "लखनऊ ग्रामीण",
   Raibareli: "रायबरेली",
   Lalganj: "लालगंज",
   Ulaw: "उलाव",
   Lav_KushNagar: "लव-कुश नगर",
   Haradoi: "हरदोई",
   Sandila: "संडीला",
   Sitapur: "सीतापुर",
   Visava: "विसावा",
   Lakhimpur: "लखीमपुर",
   Gola: "गोला",
   Gonda: "गोंडा",
   NandiniNagar: "नंदिनी नगर",
   Baharaich: "बहराइच",
   Nanpara: "नानपारा",
   Shrawasti: "श्रावस्ती",
   Saket: "साकेत",
   AmbedakarNagar: "अम्बेडकर नगर",
   Barabanki: "बाराबंकी",   
   RamSanehiGhat: "राम सनेही घाट",
   AyodhyaMahanagar: "अयोध्या महानगर",
   KashiUttarBhag: "काशी उत्तर भाग",
   KashiMadhyaBhag: "काशी मध्य भाग",
   KashiDakshinBhag: "काशी दक्षिण भाग",
   KashiJila: "काशी जिला",
   Chandoli: "चंदौली",
   SonbhadraJila: "सोनभद्र जिला",
   Renukut: "रेनुकुट",
   Duddhi: "दुद्धी",
   Mirjapur: "मिर्जापुर",
   Chunar: "चुनार",
   Bhadohi: "भदोही",
   PrayagUttar: "प्रयाग उत्तर",
   PrayagDakshin: "प्रयाग दक्षिण",
   Naini: "नैनी",
   Yamunapar: "यमुनापार",
   Gangapar: "गंगापार",
   Kunda: "कुंडा",
   Kaushambi: "कौशाम्बी",
   Sultanpur: "सुलतानपुर",
   Kadipur: "कदीपुर",
   Amethi: "अमेठी",
   Jagdispur: "जगदीसपुर",
   Jaunpur: "जौनपुर",
   MachliShahar: "मछली शहर",
   Gajipur: "गाजीपुर",
   Saidpur: "सैदपुर",
   Basti: "बस्ती",
   Itaiya: "इटैया",
   SantKabirNagar: "संत कबीर नगर",
   SiddharthNagar: "सिद्धार्थ नगर",
   Vansi: "वांसी",
   MaharajGanj: "महाराजगंज",
   GorakhpurMahanagarUttar: "गोरखपुर महानगर उत्तर",
   GorakhpurMahanagarDakshin: "गोरखपुर महानगर दक्षिण",
   GorakhpurMahanagarGramin: "गोरखपुर महानगर ग्रामीण",
   Chaurichaura: "चौरिचौरा",
   Dewariya: "देवरिया",
   Salempur: "सलेमपुर",
   Padarauna: "पदारौना",
   KushiNagar: "कुशीनगर",
   Baliya: "बलिया",
   Rasada: "रसड़ा",
   Mau: "मऊ",
   Aryamgadh: "आर्यमगढ़",
   Fulpur: "फुलपुर",
   Bagha: "बाघा",
   Betiya: "बेतिया",
   Raksaul: "रक्सौल",
   Motihari: "मोतिहारी",
   Gopalganj: "गोपालगंज",
   Siwan: "सीवान",
   Chapra: "छपरा",
   MuzafarpurMahanagar: "मुजफ्फरपुर महानगर",
   MuzafarpurPurviMahanagar: "मुजफ्फरपुर पूर्वी महानगर",
   MuzafarpurPaschimiMahanagar: "मुजफ्फरपुर पश्चिमी महानगर",
   Sitamadhi: "सीतामढ़ी",
   Shivhar: "शिवहर",
   Pupri: "पुपरी",
   Madhubani: "मधुबनी",
   Jhanjharpur: "झंझारपुर",
   Darbhanga: "दरभंगा",
   Benipur: "बेनिपुर",
   Beusarai: "बेसराई",
   Samastipur: "समस्तीपुर",
   Rosra: "रोसरा",
   Khagdiya: "खगड़िया",
   Sahrasa: "सहरसा",
   Supaul: "सुपौल",
   Madhepura: "मधेपुरा",
   Areriya: "अरेरिया",
   Purniya: "पूर्णिया",
   Katiyahar: "कटिहार",
   Navghiya: "नवघिया",
   Kishanganj: "किशनगंज",
   Ara: "आरा",
   Baksar: "बक्सर",   
   Kaimur: "कैमूर",
   Rohatas: "रोहतास",
   Vikramganj: "विक्रमगंज",
   Aurangabad: "औरंगाबाद",
   Sherghati: "शेरघाटी",
   Gaya: "गया",
   Jahanabad: "जहानाबाद",
   Araval: "अरवल",
   Danapur: "दानापुर",
   PatanaMahanagar: "पटना महानगर",
   Baadh: "बाढ़",
   Hilasa: "हिलसा",
   Nalanda: "नलंदा",
   Navada: "नवादा",
   Shekhapura: "शेखपुरा",
   Lakhisarai: "लखीसराई",
   Jamui: "जमुई",
   Munger: "मुंगेर",
   Bhagalpur: "भागलपुर",
   Banka: "बांका",
   JamashedpurMahanagar: "जमशेदपुर महानगर",
   Ghatashila: "घाटशिला",
   Saraikela: "सरायकेला",
   PashchimSinhabhoom: "पश्चिम सिंहभूम",
   RanchiMahanagar: "रांची महानगर",
   Ranchi: "रांची",
   Khunti: "खुंटी",
   Ramagadh: "रामगढ़",
   Gumala: "गुमला",
   Loharadaga: "लोहार्डागा",
   Simadega: "सिमडेगा",
   Palamu: "पालामू",
   Latehar: "लातेहार",
   Gadhava: "गढ़वा",
   Hajaribaug: "हजारीबाग",
   Chatara: "चतरा",
   Kodarama: "कोडारमा",
   Giridah: "गिरिडीह",
   DhanabadMahanagar: "धनबाद महानगर",
   Dhanabad: "धनबाद",
   BokaroMahanagar: "बोकारो महानगर",
   Bokaro: "बोकारो",
   Devaghar: "देवघर",
   Jamatada: "जमाताडा",
   Dumaka: "दुमका",
   Godada: "गोडाडा",
   Sahebganj: "साहेबगंज",
   Pakud: "पाकुड",
   Malyabanta: "मालयाबंता",
   Koraput: "कोरापुट",
   Nabarangapur: "नबरंगपुर",
   Kalahandi: "कलाहांडी",
   Nuapada: "नुआपाड़ा",
   Rayagada: "रायगढ़",
   Bolagir: "बलांगीर",
   Boudha: "बौध",
   Sonpur: "सोनपुर",
   SambalpurMahanagar: "संबलपुर महानगर",
   Sambalpur: "संबलपुर",
   Bargarh: "बड़गांव",
   Debagadh: "देबगढ़",
   RaurkelaMahanagar: "राउरकेला महानगर",
   Raurkela: "राउरकेला",
   Sundargarh: "सुंदरगढ़",
   Jharsuguda: "झारसुगुड़ा",
   Puri: "पुरी",
   Khordha: "खोरधा",
   Nayagada: "नयागढ़",
   Bhubneshwar: "भुवनेश्वर",
   Cuttak: "कटक",
   Kendrapada: "केन्द्रपाड़ा",
   Jagatsinghpur: "जगतसिंहपुर",
   Balasore: "बालासोर",
   Bhadrak: "भद्रक",
   Jajpur: "जाजपुर",
   Mayurbhan: "मयूरभंज",
   Keonjhar: "केन्द्रीय",
   Rairangpur: "रैरंगपुर",
   Dhenkanal: "धेनकनाल",   
   Angul: "अंगुल",
   Ganjam: "गंजम",
   Gajpati: "गजपति",
   Kandhamal: "कंधमाल",
   Ghumusar: "घुमुसर",
   Midnapur: "मिदनापुर",
   Jhargram: "झारग्राम",
   Tamrolipt: "तम्रोलिप्त",
   Kanthi: "कांठी",
   HaoraGramin: "हावड़ा ग्रामीण",
   Barrakpur: "बाराकपुर",
   Barasat: "बारासात",
   Bashirhat: "बशीरहाट",
   Sundarban: "सुंदरबन",
   Baruipur: "बारुइपुर",
   Gangasagar: "गंगासागर",
   DakshinAndaman: "दक्षिण अंडमान",
   MadhyaAndaman: "मध्या अंडमान",
   UttarAndaman: "उत्तर अंडमान",
   DakshinHowrah: "दक्षिण हावड़ा",
   MaddhyaHowrah: "मध्य हावड़ा",
   UttarHowrah: "उत्तर हावड़ा",
   UttarPaschimHowrah: "उत्तर पश्चिम हावड़ा",
   KolakataUttar: "कोलकाता उत्तर",
   KolakataMaddhya: "कोलकाता मध्य",
   KolakataPashchim: "कोलकाता पश्चिम",
   KolakataPoorw: "कोलकाता पूर्व",
   KolakataUttarPoorw: "कोलकाता उत्तर पूर्व",
   Baghajatin: "बाघाजातिन",
   Deshpriya: "देशप्रिय",
   Thakurpukur: "ठाकुरपुकुर",
   Kalighat: "कालाघाट",
   Kabitirth: "कबितिर्थ",
   UttarMurshidabad: "उत्तर मुर्शिदाबाद",
   DakshinMurshidabad: "दक्षिण मुर्शिदाबाद",
   PaschimMurshidabad: "पश्चिम मुर्शिदाबाद",
   UttarNadiya: "उत्तर नदिया",
   DokhinNadiya: "दक्षिण नदिया",
   UttarBeerbhumi: "उत्तर बीरभूमि",
   DakshinBeerbhumi: "दक्षिण बीरभूमि",
   Katoya: "कटोया",
   Vardhaman: "वर्धमान",
   Asansol: "आसनसोल",
   UttarBankukra: "उत्तर बैंकुका",
   DakshinBankura: "दक्षिण बांकुरा",
   Purulia: "पुरुलिया",
   Hugali: "हुगली",
   Tarkeshbar: "तारकेश्वर",
   Alipurdwar: "अलीपुरद्वार",
   CoochBihar: "कूच बिहार",
   PashchimCoochBihar: "पश्चिम कूच बिहार",
   Jalpaigudi: "जलपाईगुड़ी",
   Siligudi: "सिलीगुड़ी",
   Darjiling: "दार्जिलिंग",
   Kalimpong: "कालिम्पोंग",
   SikkimUttarPoorwa: "सिक्किम उत्तर पूर्व",
   SikkimDaxinPashchim: "सिक्किम दक्षिण पश्चिम",
   Eswarpur: "ईश्वरपुर",
   UttarDinajpur: "उत्तर दिनाजपुर",
   DaxinDinajpur: "दक्षिण दिनाजपुर",
   Malda: "मालदा",
   UttarMalda: "उत्तर मालदा",
   UttarMursidabad: "उत्तर मुर्शिदाबाद",
   DakshinKachad: "दक्षिण कचड़",
   MadhyaKachad: "मध्य कचड़",
   Lakshipur: "लक्षीपुर",
   PaschimKachad: "पश्चिम कचड़",
   Aizwal: "आइज़ोल",
   Langathlai: "लंगथलई",
   Hailakandi: "हाइलाकांडी",
   RamkrishnaNagar: "रामकृष्ण नगर",
   ShreeBhoomi: "श्रीभूमि",
   Dimahasao: "डिमाहसाओ",
   Umranshu: "उमरांशु",
   Thoubal: "थौबाल",
   Chandel: "चंदेल",
   Imphal: "इंफाल",
   Ukhrul: "उखरुल",
   Bishnupur: "बिशनुपुर",
   Churachandpur: "चुराचांदपुर",
   Senapati: "सेनापति",
   Tamenglong: "तामेग्लांग",
   Tinsukiya: "तिनसुकिया",
   Dibrugadh: "डिब्रूगढ़",
   Shivasagar: "शिवसागर",
   Golaghat: "गोलाघाट",
   Saraidev: "सारादेव",
   Joraghat: "जोराघाट",
   Majuli: "माजुली",
   Dhemaji: "धेमाजी",
   Vishwanath: "विश्वनाथ",
   Tejpur: "तेज़पुर",
   Udalguri: "उदलगुरी",
   Darang: "दरंग",
   Marigaon: "मरीगाँव",
   Hojai: "होजाई",
   Nagaon: "नगांव",
   PurvKarbianglong: "पूर्व कार्बियांगलोंग",
   PaschimKarbianglong: "पश्चिम कार्बियांगलोंग",
   MadhyaKarbianglong: "मध्य कार्बियांगलोंग",
   DakshinKamarup: "दक्षिण कामरूप",
   Govalpara: "गुवालपारा",
   Guwahati: "गुवाहाटी",
   Kamarup: "कामरूप",
   Nalabari: "नलबाड़ी",
   Baska: "बक्सा",
   Barapeta: "बरपेटा",
   Kokarajhar: "कोकराझार",
   Chirang: "चिरांग",
   Bongaigaon: "बोंगाईगांव",
   Dhubdi: "धुबड़ी",
   EastKhasiHills: "पूर्व खासी हिल्स",
   WestKhasiHills: "पश्चिम खासी हिल्स",
   Jayantiya: "जयंतिया",
   EastGaroPahad: "पूर्व गारो पहाड़",
   SouthwestGaroPahad: "दक्षिण पश्चिम गारो पहाड़",
   NorthwestGaroPahad: "उत्तर पश्चिम गारो पहाड़",
   UttarNagbhumi: "उत्तर नागभूमि",
   DakshinNagbhumi: "दक्षिण नागभूमि",
   Longding: "लॉंगडिंग",
   Tirap: "तिरप",
   Changlang: "चांगलांग",
   Namsaie: "नामसाइ",
   Lohit: "लोहित",
   Anjao: "अंजाओ",
   Lower: "लोअर",
   Dibang: "दिबांग",
   East: "पूर्व",
   West: "पश्चिम",
   Upper: "ऊपर",
   Kamale: "कमले",
   Karadadi: "कराददी",
   Kurumkume: "कुरुमकुमे",
   Papumpare: "पापम्पारे",
   Tawang: "तवांग",
   UttarTripura: "उत्तर त्रिपुरा",
   Unnkoti: "उन्नकोटी",
   Dholai: "ढोलाई",
   Khovai: "खोवाई",
   PaschimTripura: "पश्चिम त्रिपुरा",
   Sepahijila: "सेफाहिजिला",
   Gomti: "गोमती",
   DakshinTripura: "दक्षिण त्रिपुरा",   
   GorakhapurMahanagarUttar: "गोरखपुर महानगर उत्तर",
   GorakhapurMahanagarGramin: "गोरखपुर महानगर ग्रामीण",
   GorakhapurMahanagarDakshin: "गोरखपुर महानगर दक्षिण",
   kotaMahaanagar: "कोटा महानगर",
   NaviMumbai: "नवी मुंबई",
   NashikMananagar: "नाशिक महानगर",
   THIRUVOTTIYURBHAG: "थिरुवोट्टियूर भाग",
   KOZHIKODEMAHANAGAR: "कोझिकोडे महानगर",
   MaduariMahanagar: "मदुरै महानगर",
   Triuvarur: "तिरुवरूर",
   Nagapattanam: "नागपट्टिनम",
   Pattukkottai: "पट्टुकोट्टई",
   Tanjavur: "तंजावुर",
   Ramanathpuram: "रामनाथपुरम",
   KOLLAMMAHANAGAR: "कोल्लम महानगर",
   KOLLAMGRAMAM: "कोल्लम ग्रामम",
   THIRUVANANTHAPURAMGRAMAM: "तिरुवनंतपुरम ग्रामम",
   THIRUVANANTHAPURAMMAHANAGAR: "तिरुवनंतपुरम महानगर",
   Kumari_E: "कुमारी ईस्ट",
   Kumari_W:"कुमारी वेस्ट",
   Chengalpattu: "चेंगलपट्टू",
Kanchipuram: "कांचीपुरम",
Ranipettai: "रानीपेट्टई",
Thiruvallur: "तिरुवल्लूर",
Namakkal: "नमक्कल",
Erode: "इरोड",
Gobichettipalayam: "गोबिचेट्टिपालयम",
Krishnagiri: "कृष्णगिरि",
Attur: "अट्टूर",
Dharmapuri: "धर्मपुरी",
Salem: "सेलम",
Thiruppattur: "तिरुप्पत्तूर",
Vandavasi: "वंदावासी",
Vellore: "वेल्लोर",
Tiruvannamalai: "तिरुवन्नामलाई",
Pondy: "पॉन्डी",
Cuddalore: "कुड्डालोर",
Kallakurichi: "कल्लकुरिची",
Villupuram: "विल्लुपुरम",



    
}


const KendraTranslation={
    AkhilBhartiya:"अखिल भारतीय"
}

KendraTranslation["Akhil Bhartiya"] = KendraTranslation["AkhilBhartiya"]

kshetraTranslation["Dakshin Madhya"] = kshetraTranslation["DakshinMadhya"];
kshetraTranslation["Uttar Paschim"] = kshetraTranslation["UttarPaschim"];
kshetraTranslation["Paschim UP"] = kshetraTranslation["PaschimUP"];
kshetraTranslation["Uttar Purv"] = kshetraTranslation["UttarPurv"];
kshetraTranslation["Purv UP"] = kshetraTranslation["PurvUP"];



PrantTranslation["Uttar Kerala"] = PrantTranslation["UttarKerala"];
PrantTranslation["Dakshin Kerala"] = PrantTranslation["DakshinKerala"];
PrantTranslation["Dakshin Tamilnadu"] = PrantTranslation["DakshinTamilnadu"];
PrantTranslation["Uttar Tamilnadu"] = PrantTranslation["UttarTamilnadu"];
PrantTranslation["Karnatak Uttar"] = PrantTranslation["KarnatakUttar"];
PrantTranslation["Karnataka Dakshin"] = PrantTranslation["KarnatakaDakshin"];
PrantTranslation["Paschim Maharashtra"] = PrantTranslation["PaschimMaharashtra"];
PrantTranslation["Madhya Bharat"] = PrantTranslation["MadhyaBharat"];
PrantTranslation["Jammu Kashimir"] = PrantTranslation["JammuKashimir"];
PrantTranslation["Uttar Bihar"] = PrantTranslation["UttarBihar"];
PrantTranslation["Dakshin Bihar"] = PrantTranslation["DakshinBihar"];
PrantTranslation["Odisa Paschim"] = PrantTranslation["OdisaPaschim"];
PrantTranslation["Odisha Purv"] = PrantTranslation["OdishaPurv"];
PrantTranslation["Dakshin Bang"] = PrantTranslation["DakshinBang"];
PrantTranslation["Madhya Bang"] = PrantTranslation["MadhyaBang"];
PrantTranslation["Uttar Bang"] = PrantTranslation["UttarBang"];
PrantTranslation["Dakshin Assam"] = PrantTranslation["DakshinAssam"];
PrantTranslation["Uttar Assam"] = PrantTranslation["UttarAssam"];







VibhagTranslation["East Arunachal Pradesh"] = VibhagTranslation["EastArunachalPradesh"]
VibhagTranslation["Bengaluru Dakshin"] = VibhagTranslation["BengaluruDakshin"]
VibhagTranslation["Bengaluru Uttar"] = VibhagTranslation["BengaluruUttar"]

VibhagTranslation["West Arunachal Pradesh"] = VibhagTranslation["WestArunachalPradesh"]
VibhagTranslation["Central Arunachal Pradesh"] = VibhagTranslation["CentralArunachalPradesh"]
VibhagTranslation["North Assam"] = VibhagTranslation["NorthAssam"]
VibhagTranslation["South Assam"] = VibhagTranslation["SouthAssam"]
VibhagTranslation["Central Assam"] = VibhagTranslation["CentralAssam"]
VibhagTranslation["Upper Assam"] = VibhagTranslation["UpperAssam"]
VibhagTranslation["Lower Assam"] = VibhagTranslation["LowerAssam"]
VibhagTranslation["West Assam"] = VibhagTranslation["WestAssam"]
VibhagTranslation["North Bihar"] = VibhagTranslation["NorthBihar"]
VibhagTranslation["South Bihar"] = VibhagTranslation["SouthBihar"]
VibhagTranslation["Central Bihar"] = VibhagTranslation["CentralBihar"]
VibhagTranslation["East Bihar"] = VibhagTranslation["EastBihar"]
VibhagTranslation["West Bihar"] = VibhagTranslation["WestBihar"]
VibhagTranslation["East Chhattisgarh"] = VibhagTranslation["EastChhattisgarh"]
VibhagTranslation["West Chhattisgarh"] = VibhagTranslation["WestChhattisgarh"]
VibhagTranslation["North Chhattisgarh"] = VibhagTranslation["NorthChhattisgarh"]
VibhagTranslation["South Chhattisgarh"] = VibhagTranslation["SouthChhattisgarh"]
VibhagTranslation["North Gujarat"] = VibhagTranslation["NorthGujarat"]
VibhagTranslation["South Gujarat"] = VibhagTranslation["SouthGujarat"]
VibhagTranslation["Central Gujarat"] = VibhagTranslation["CentralGujarat"]
// VibhagTranslation["Saurashtra"] = VibhagTranslation["Saurashtra"]
// VibhagTranslation["Kutch"] = VibhagTranslation["Kutch"]
VibhagTranslation["North Haryana"] = VibhagTranslation["NorthHaryana"]
VibhagTranslation["South Haryana"] = VibhagTranslation["SouthHaryana"]
VibhagTranslation["West Haryana"] = VibhagTranslation["WestHaryana"]
VibhagTranslation["East Haryana"] = VibhagTranslation["EastHaryana"]
VibhagTranslation["North Himachal Pradesh"] = VibhagTranslation["NorthHimachalPradesh"]
VibhagTranslation["South Himachal Pradesh"] = VibhagTranslation["SouthHimachalPradesh"]
VibhagTranslation["East Himachal Pradesh"] = VibhagTranslation["EastHimachalPradesh"]
VibhagTranslation["West Himachal Pradesh"] = VibhagTranslation["WestHimachalPradesh"]
// VibhagTranslation["Jammu"] = VibhagTranslation["Jammu"]
// VibhagTranslation["Kashmir"] = VibhagTranslation["Kashmir"]
// VibhagTranslation["Ladakh"] = VibhagTranslation["Ladakh"]
VibhagTranslation["North Jharkhand"] = VibhagTranslation["NorthJharkhand"]
VibhagTranslation["South Jharkhand"] = VibhagTranslation["SouthJharkhand"]
VibhagTranslation["East Jharkhand"] = VibhagTranslation["EastJharkhand"]
VibhagTranslation["West Jharkhand"] = VibhagTranslation["WestJharkhand"]
VibhagTranslation["North Karnataka"] = VibhagTranslation["NorthKarnataka"]
VibhagTranslation["South Karnataka"] = VibhagTranslation["SouthKarnataka"]
VibhagTranslation["Central Karnataka"] = VibhagTranslation["CentralKarnataka"]
VibhagTranslation["Coastal Karnataka"] = VibhagTranslation["CoastalKarnataka"]
VibhagTranslation["North Kerala"] = VibhagTranslation["NorthKerala"]
VibhagTranslation["South Kerala"] = VibhagTranslation["SouthKerala"]
VibhagTranslation["Central Kerala"] = VibhagTranslation["CentralKerala"]
VibhagTranslation["North Madhya Pradesh"] = VibhagTranslation["NorthMadhyaPradesh"]
VibhagTranslation["South Madhya Pradesh"] = VibhagTranslation["SouthMadhyaPradesh"]
VibhagTranslation["East Madhya Pradesh"] = VibhagTranslation["EastMadhyaPradesh"]
VibhagTranslation["West Madhya Pradesh"] = VibhagTranslation["WestMadhyaPradesh"]
VibhagTranslation["Central Madhya Pradesh"] = VibhagTranslation["CentralMadhyaPradesh"]
VibhagTranslation["North Maharashtra"] = VibhagTranslation["NorthMaharashtra"]
VibhagTranslation["South Maharashtra"] = VibhagTranslation["SouthMaharashtra"]
VibhagTranslation["East Maharashtra"] = VibhagTranslation["EastMaharashtra"]
VibhagTranslation["West Maharashtra"] = VibhagTranslation["WestMaharashtra"]
// VibhagTranslation["Konkan"] = VibhagTranslation["Konkan"]
VibhagTranslation["North Odisha"] = VibhagTranslation["NorthOdisha"]
VibhagTranslation["South Odisha"] = VibhagTranslation["SouthOdisha"]
VibhagTranslation["Central Odisha"] = VibhagTranslation["CentralOdisha"]
VibhagTranslation["East Rajasthan"] = VibhagTranslation["EastRajasthan"]
VibhagTranslation["West Rajasthan"] = VibhagTranslation["WestRajasthan"]
VibhagTranslation["North Rajasthan"] = VibhagTranslation["NorthRajasthan"]
VibhagTranslation["South Rajasthan"] = VibhagTranslation["SouthRajasthan"]
VibhagTranslation["North Tamil Nadu"] = VibhagTranslation["NorthTamilNadu"]
VibhagTranslation["South Tamil Nadu"] = VibhagTranslation["SouthTamilNadu"]
VibhagTranslation["Central Tamil Nadu"] = VibhagTranslation["CentralTamilNadu"]
VibhagTranslation["East Tamil Nadu"] = VibhagTranslation["EastTamilNadu"]
VibhagTranslation["West Tamil Nadu"] = VibhagTranslation["WestTamilNadu"]
VibhagTranslation["North Telangana"] = VibhagTranslation["NorthTelangana"]
VibhagTranslation["South Telangana"] = VibhagTranslation["SouthTelangana"]
VibhagTranslation["North Uttar Pradesh"] = VibhagTranslation["NorthUttarPradesh"]
VibhagTranslation["South Uttar Pradesh"] = VibhagTranslation["SouthUttarPradesh"]
VibhagTranslation["East Uttar Pradesh"] = VibhagTranslation["EastUttarPradesh"]
VibhagTranslation["West Uttar Pradesh"] = VibhagTranslation["WestUttarPradesh"]
VibhagTranslation["Central Uttar Pradesh"] = VibhagTranslation["CentralUttarPradesh"]
VibhagTranslation["North West Bengal"] = VibhagTranslation["NorthWestBengal"]
VibhagTranslation["South West Bengal"] = VibhagTranslation["SouthWestBengal"]
VibhagTranslation["Central West Bengal"] = VibhagTranslation["CentralWestBengal"]
VibhagTranslation["East West Bengal"] = VibhagTranslation["EastWestBengal"]
VibhagTranslation["West West Bengal"] = VibhagTranslation["WestWestBengal"]

VibhagTranslation["Siddharth Nagar"] = VibhagTranslation["SiddharthNagar"];
VibhagTranslation["Chitrakoot Dham"] = VibhagTranslation["ChitrakootDham"];
VibhagTranslation["Dharm Nagar"] = VibhagTranslation["DharmNagar"];
VibhagTranslation["jaipur"] = VibhagTranslation["Jaipur"];
VibhagTranslation["Sawai Madhopur"] = VibhagTranslation["SawaiMadhopur"];
VibhagTranslation["Shree Ganganagar"] = VibhagTranslation["ShreeGanganagar"];
// VibhagTranslation["Kathua"] = VibhagTranslation["Kathua"];
// VibhagTranslation["Yamunavihar"] = VibhagTranslation["Yamunavihar"];
VibhagTranslation["Uttari vibhag"] = VibhagTranslation["UttariVibhag"];
// VibhagTranslation["Ramkrushnapuram"] = VibhagTranslation["Ramkrushnapuram"];
// VibhagTranslation["Pashchimi"] = VibhagTranslation["Pashchimi"];
// VibhagTranslation["Jhandewala"] = VibhagTranslation["Jhandewala"];
// VibhagTranslation["Mandi"] = VibhagTranslation["Mandi"];
VibhagTranslation["Pune Mahanagar"] = VibhagTranslation["PuneMahanagar"];
VibhagTranslation["Karnawati Purva"] = VibhagTranslation["KarnawatiPurva"];
VibhagTranslation["Karnawati Paschim"] = VibhagTranslation["KarnawatiPaschim"];
VibhagTranslation["Uttar Bastar"] = VibhagTranslation["UttarBastar"];
VibhagTranslation["Madhya Bastar"] = VibhagTranslation["MadhyaBastar"];
VibhagTranslation["Dakshin Bastar"] = VibhagTranslation["DakshinBastar"];
VibhagTranslation["Uttar 24 Paragana"] = VibhagTranslation["Uttar24Paragana"];
VibhagTranslation["Andaman & Nicobar"] = VibhagTranslation["AndamanandNicobar"];
VibhagTranslation["Kolakata Purv"] = VibhagTranslation["KolkataPurv"];
VibhagTranslation["Kolakata Uttar"] = VibhagTranslation["KolkataUttar"];
VibhagTranslation["Kolakata dakshin pashchim"] = VibhagTranslation["KolkataDakshinPashchim"];
VibhagTranslation["Kolakata dakshin poorw"] = VibhagTranslation["KolkataDakshinPoorw"];
VibhagTranslation["Howrah Mahanagar"] = VibhagTranslation["HowrahMahanagar"];
VibhagTranslation["Dakshin 24 Paragana"] = VibhagTranslation["Dakshin24Paragana"];
VibhagTranslation["Cooch Bihar"] = VibhagTranslation["CoochBihar"];
VibhagTranslation["Uttari vibhag"] = VibhagTranslation["Uttarivibhag"];








JilaTranslation["Vadodra Gramya"] = JilaTranslation["VadodraGramya"];
JilaTranslation["Surat Gramya"] = JilaTranslation["SuratGramya"];
JilaTranslation["Rajkot Mahanagar"] = JilaTranslation["RajkotMahanagar"];
JilaTranslation["Pune Gramin"] = JilaTranslation["PuneGramin"];
JilaTranslation["Nashik Gramin"] = JilaTranslation["NashikGramin"];
JilaTranslation["Nashik Mahanagar"] = JilaTranslation["NashikMahanagar"];
JilaTranslation["Sambhajinagar Shahar"] = JilaTranslation["SambhajinagarShahar"];
JilaTranslation["Mangluru Mahanagar"] = JilaTranslation["MangluruMahanagar"];
JilaTranslation["Mangluru Gramantar"] = JilaTranslation["MangluruGramantar"];
JilaTranslation["Golkonda Bhag"] = JilaTranslation["GolkondaBhag"];
JilaTranslation["Barkatpura Bhag"] = JilaTranslation["BarkatpuraBhag"];
JilaTranslation["Mmaheshwaram JIla"] = JilaTranslation["MmaheshwaramJIla"];
JilaTranslation["Dilkhushnagar Bhag"] = JilaTranslation["DilkhushnagarBhag"];
JilaTranslation["Charminar Bhag"] = JilaTranslation["CharminarBhag"];
JilaTranslation["Bhadradi kottagudem"] = JilaTranslation["Bhadradikottagudem"];
JilaTranslation["Nagar Karnool"] = JilaTranslation["NagarKarnool"];
JilaTranslation["Boeinpalli Bhag"] = JilaTranslation["BoeinpalliBhag"];
JilaTranslation["Kuktpalli Bhag"] = JilaTranslation["KuktpalliBhag"];
JilaTranslation["Uppal Bhag"] = JilaTranslation["UppalBhag"];
JilaTranslation["Malkajigiri Bhag"] = JilaTranslation["MalkajigiriBhag"];
JilaTranslation["Secunderabad Bhag"] = JilaTranslation["SecunderabadBhag"];
JilaTranslation["Lav - Kush Nagar"] = JilaTranslation["Lav_KushNagar"];



// JilaTranslation["MORADABAD"] = JilaTranslation["MORADABAD"];
// JilaTranslation["RAMPUR"] = JilaTranslation["RAMPUR"];
// JilaTranslation["THAKURDWARA"] = JilaTranslation["THAKURDWARA"];
// JilaTranslation["karnal"] = JilaTranslation["karnal"];
// JilaTranslation["dadlaghat"] = JilaTranslation["dadlaghat"];
// JilaTranslation["HAPUR"] = JilaTranslation["HAPUR"];
// JilaTranslation["MEERUT"] = JilaTranslation["MEERUT"];
// JilaTranslation["MAWANA"] = JilaTranslation["MAWANA"];
// JilaTranslation["SARDHANA"] = JilaTranslation["SARDHANA"];
// JilaTranslation["SAMBHAL"] = JilaTranslation["SAMBHAL"];
// JilaTranslation["BABARALA"] = JilaTranslation["BABARALA"];
// JilaTranslation["AMROHA"] = JilaTranslation["AMROHA"];
// JilaTranslation["DHAMPUR"] = JilaTranslation["DHAMPUR"];
// JilaTranslation["BIJNOR"] = JilaTranslation["BIJNOR"];
// JilaTranslation["BEHAT"] = JilaTranslation["BEHAT"];
JilaTranslation["DEV VRIND"] = JilaTranslation["DEVVRIND"];
// JilaTranslation["SAHARANPUR"] = JilaTranslation["SAHARANPUR"];
// JilaTranslation["BAGPAT"] = JilaTranslation["BAGPAT"];
// JilaTranslation["LAXMINAGAR"] = JilaTranslation["LAXMINAGAR"];
// JilaTranslation["SHAMLI"] = JilaTranslation["SHAMLI"];
// JilaTranslation["Kanchipuram"] = JilaTranslation["Kanchipuram"];
// JilaTranslation["Ranipettai"] = JilaTranslation["Ranipettai"];
// JilaTranslation["Chengalpattu"] = JilaTranslation["Chengalpattu"];
// JilaTranslation["Thiruvallur"] = JilaTranslation["Thiruvallur"];
// JilaTranslation["Namakkal"] = JilaTranslation["Namakkal"];
// JilaTranslation["Erode"] = JilaTranslation["Erode"];
// JilaTranslation["Gobichettipalayam"] = JilaTranslation["Gobichettipalayam"];
// JilaTranslation["Krishnagiri"] = JilaTranslation["Krishnagiri"];
// JilaTranslation["Attur"] = JilaTranslation["Attur"];
// JilaTranslation["Dharmapuri"] = JilaTranslation["Dharmapuri"];
// JilaTranslation["Salem"] = JilaTranslation["Salem"];
// JilaTranslation["Thiruppattur"] = JilaTranslation["Thiruppattur"];
// JilaTranslation["Vandavasi"] = JilaTranslation["Vandavasi"];
// JilaTranslation["Vellore"] = JilaTranslation["Vellore"];
// JilaTranslation["Tiruvannamalai"] = JilaTranslation["Tiruvannamalai"];
// JilaTranslation["Pondy"] = JilaTranslation["Pondy"];
// JilaTranslation["Cuddalore"] = JilaTranslation["Cuddalore"];
// JilaTranslation["Villupuram"] = JilaTranslation["Villupuram"];
// JilaTranslation["Virudunagar"] = JilaTranslation["Virudunagar"];
// JilaTranslation["Theni"] = JilaTranslation["Theni"];
// JilaTranslation["Madurai"] = JilaTranslation["Madurai"];
// JilaTranslation["Dindukkal"] = JilaTranslation["Dindukkal"];
// JilaTranslation["Pollachi"] = JilaTranslation["Pollachi"];
// JilaTranslation["Nilagiri"] = JilaTranslation["Nilagiri"];
// JilaTranslation["Kovai"] = JilaTranslation["Kovai"];
// JilaTranslation["Triuvarur"] = JilaTranslation["Triuvarur"];
// JilaTranslation["Nagapattanam"] = JilaTranslation["Nagapattanam"];
// JilaTranslation["Pattukkottai"] = JilaTranslation["Pattukkottai"];
// JilaTranslation["Tanjavur"] = JilaTranslation["Tanjavur"];
// JilaTranslation["Sivagangai"] = JilaTranslation["Sivagangai"];
// JilaTranslation["Ramanathpuram"] = JilaTranslation["Ramanathpuram"];
// JilaTranslation["Aranthangi"] = JilaTranslation["Aranthangi"];
// JilaTranslation["Pudukkottai"] = JilaTranslation["Pudukkottai"];
// JilaTranslation["Tenkasi"] = JilaTranslation["Tenkasi"];
// JilaTranslation["Tirunelveli"] = JilaTranslation["Tirunelveli"];
// JilaTranslation["Thoothukkudi"] = JilaTranslation["Thoothukkudi"];
// JilaTranslation["Tiruchendur"] = JilaTranslation["Tiruchendur"];
// JilaTranslation["Perambalur"] = JilaTranslation["Perambalur"];
// JilaTranslation["Tiruchy"] = JilaTranslation["Tiruchy"];
// JilaTranslation["Ariyalur"] = JilaTranslation["Ariyalur"];
// JilaTranslation["Dharapuram"] = JilaTranslation["Dharapuram"];
// JilaTranslation["Karur"] = JilaTranslation["Karur"];
// JilaTranslation["Tiruppur"] = JilaTranslation["Tiruppur"];
JilaTranslation["Sanga Reddy"] = JilaTranslation["SangaReddy"];
JilaTranslation["Sant Kabir Nagar"] = JilaTranslation["SantKabirNagar"];
JilaTranslation["Gorakhapur Mahanagar Uttar"] = JilaTranslation["GorakhapurMahanagarUttar"];
JilaTranslation["Gorakhapur Mahanagar Gramin"] = JilaTranslation["GorakhapurMahanagarGramin"];
JilaTranslation["Gorakhapur Mahanagar Dakshin"] = JilaTranslation["GorakhapurMahanagarDakshin"];
JilaTranslation["Siddharth Nagar"] = JilaTranslation["SiddharthNagar"];
JilaTranslation["Kushi Nagar"] = JilaTranslation["KushiNagar"];
JilaTranslation["Nandini Nagar"] = JilaTranslation["NandiniNagar"];
JilaTranslation["Ram Sanehi Ghat"] = JilaTranslation["RamSanehiGhat"];
JilaTranslation["Ayodhya Mahanagar"] = JilaTranslation["AyodhyaMahanagar"];
JilaTranslation["Ambedakar Nagar"] = JilaTranslation["AmbedakarNagar"];
JilaTranslation["Machli Shahar"] = JilaTranslation["MachliShahar"];
JilaTranslation["Sonbhadra Jila"] = JilaTranslation["SonbhadraJila"];
JilaTranslation["Kashi Dakshin Bhag"] = JilaTranslation["KashiDakshinBhag"];
JilaTranslation["Kashi Madhya Bhag"] = JilaTranslation["KashiMadhyaBhag"];
JilaTranslation["Kashi Uttar Bhag"] = JilaTranslation["KashiUttarBhag"];
JilaTranslation["Kashi Jila"] = JilaTranslation["KashiJila"];
JilaTranslation["Shree Bhoomi"] = JilaTranslation["ShreeBhoomi"];
JilaTranslation["Ramkrishna Nagar"] = JilaTranslation["RamkrishnaNagar"];
JilaTranslation["North west Garo Pahad"] = JilaTranslation["NorthWestGaroPahad"];
JilaTranslation["South west Garo Pahad"] = JilaTranslation["SouthWestGaroPahad"];
JilaTranslation["Madhya Karbianglong"] = JilaTranslation["MadhyaKarbianglong"];
JilaTranslation["Purv Karbianglong"] = JilaTranslation["PurvKarbianglong"];
JilaTranslation["Paschim Karbianglong"] = JilaTranslation["PaschimKarbianglong"];
JilaTranslation["Dakshin Kamarup"] = JilaTranslation["DakshinKamarup"];
JilaTranslation["Chhipa Baroda"] = JilaTranslation["ChhipaBaroda"];
JilaTranslation["Bhawani Mandi"] = JilaTranslation["BhawaniMandi"];
JilaTranslation["kota mahaanagar"] = JilaTranslation["kotaMahaanagar"];
JilaTranslation["Sanganer mahanagar"] = JilaTranslation["SanganerMahanagar"];
JilaTranslation["Sawai Madhopur"] = JilaTranslation["SawaiMadhopur"];
JilaTranslation["Bikaner mahanagar"] = JilaTranslation["BikanerMahanagar"];
JilaTranslation["shaheed Bhagat Singh nagar"] = JilaTranslation["ShaheedBhagatSinghNagar"];
JilaTranslation["Jammu Mahanagar"] = JilaTranslation["JammuMahanagar"];
JilaTranslation["Ranveersingh Pura"] = JilaTranslation["RanveersinghPura"];
JilaTranslation["Mukhrjee nagar"] = JilaTranslation["MukhrjeeNagar"];
JilaTranslation["Bareli Mahanagar"] = JilaTranslation["BareliMahanagar"];
JilaTranslation["Chandra Nagar"] = JilaTranslation["ChandraNagar"];
JilaTranslation["Fatehpur Sikri"] = JilaTranslation["FatehpurSikri"];
JilaTranslation["Shajipur Mahanagar"] = JilaTranslation["ShajipurMahanagar"];
JilaTranslation["Mathura Mahanagar"] = JilaTranslation["MathuraMahanagar"];
JilaTranslation["Harigarh Mahanagar"] = JilaTranslation["HarigarhMahanagar"];
JilaTranslation["Udhamsinh Nagar"] = JilaTranslation["UdhamsinhNagar"];
JilaTranslation["Uttar Kashi"] = JilaTranslation["UttarKashi"];
JilaTranslation["Dew prayag"] = JilaTranslation["DewPrayag"];
JilaTranslation["Deharadun Dakshin"] = JilaTranslation["DeharadunDakshin"];
JilaTranslation["Deharadun Uttar"] = JilaTranslation["DeharadunUttar"];
JilaTranslation["Vikas Nagar"] = JilaTranslation["VikasNagar"];
JilaTranslation["Rudra Prayag"] = JilaTranslation["RudraPrayag"];
JilaTranslation["Gaziabad Mahanagar"] = JilaTranslation["GaziabadMahanagar"];
JilaTranslation["NOIDA Mahanagar"] = JilaTranslation["NOIDAMahanagar"];
JilaTranslation["Goutambuddh Nagar"] = JilaTranslation["GoutambuddhNagar"];
JilaTranslation["Anuppur Shahar"] = JilaTranslation["AnuppurShahar"];
JilaTranslation["Navi Mumbai"] = JilaTranslation["NaviMumbai"];
JilaTranslation["Dakshin Ratnagiri"] = JilaTranslation["DakshinRatnagiri"];
JilaTranslation["Uttar Ratnagiri"] = JilaTranslation["UttarRatnagiri"];
JilaTranslation["Dakshin Goa"] = JilaTranslation["DakshinGoa"];
JilaTranslation["Uttar Goa"] = JilaTranslation["UttarGoa"];
JilaTranslation["Kachha Purva"] = JilaTranslation["KachhaPurva"];
JilaTranslation["Kachha Pashim"] = JilaTranslation["KachhaPashim"];
JilaTranslation["Poorva Beed"] = JilaTranslation["PoorvaBeed"];
JilaTranslation["Pashchim Beed"] = JilaTranslation["PashchimBeed"];
JilaTranslation["Uttar Nagar"] = JilaTranslation["UttarNagar"];
JilaTranslation["Nashik Mananagar"] = JilaTranslation["NashikMananagar"];
JilaTranslation["Dakshin Nagar"] = JilaTranslation["DakshinNagar"];
JilaTranslation["Pimpri Chinchawad"] = JilaTranslation["PimpriChinchawad"];
JilaTranslation["Chota Uadipur"] = JilaTranslation["ChotaUadipur"];
JilaTranslation["Ashok Nagar"] = JilaTranslation["AshokNagar"];
JilaTranslation["Ambagadh Chowki"] = JilaTranslation["AmbagadhChowki"];
JilaTranslation["Lavkush nagar"] = JilaTranslation["Lavkushnagar"];
JilaTranslation["Kalla kurichi"] = JilaTranslation["Kallakurichi"];
JilaTranslation["Haora Gramin"] = JilaTranslation["HaoraGramin"];
JilaTranslation["Kolakata uttar poorw"] = JilaTranslation["KolakataUttarPoorw"];
JilaTranslation["Maddhya Howrah"] = JilaTranslation["MaddhyaHowrah"];
JilaTranslation["Kolakata uttar"] = JilaTranslation["KolakataUttar"];
JilaTranslation["Kolakata Pashchim"] = JilaTranslation["KolakataPashchim"];
JilaTranslation["Sikkim Daxin pashchim"] = JilaTranslation["SikkimDaxinPashchim"];
JilaTranslation["Sikkim Uttar Poorwa"] = JilaTranslation["SikkimUttarPoorwa"];
JilaTranslation["Pashchim Cooch Bihar"] = JilaTranslation["PashchimCoochBihar"];
JilaTranslation["Cooch Bihar"] = JilaTranslation["CoochBihar"];
JilaTranslation["Daxin Dinajpur"] = JilaTranslation["DaxinDinajpur"];
JilaTranslation["Dakshin Bankura"] = JilaTranslation["DakshinBankura"];
JilaTranslation["Uttar bankukra"] = JilaTranslation["UttarBankukra"];
JilaTranslation["Dokhin Nadiya"] = JilaTranslation["DokhinNadiya"];
JilaTranslation["KOZHIKODE MAHANAGAR"] = JilaTranslation["KOZHIKODEMAHANAGAR"];
JilaTranslation["KOZHIKODE GRAMAM"] = JilaTranslation["KOZHIKODEGRAMAM"];
JilaTranslation["Maduari Mahanagar"] = JilaTranslation["MaduariMahanagar"];
JilaTranslation["KOLLAM MAHANAGAR"] = JilaTranslation["KOLLAMMAHANAGAR"];
JilaTranslation["THIRUVOTTIYUR BHAG"] = JilaTranslation["THIRUVOTTIYURBHAG"];
JilaTranslation["KOLLAM GRAMAM"] = JilaTranslation["KOLLAMGRAMAM"];
JilaTranslation["KOCHI MAHANAGAR"] = JilaTranslation["KOCHIMAHANAGAR"];
JilaTranslation["THIRUVANANTHAPURAM GRAMAM"] = JilaTranslation["THIRUVANANTHAPURAMGRAMAM"];
JilaTranslation["THIRUVANANTHAPURAM MAHANAGAR"] = JilaTranslation["THIRUVANANTHAPURAMMAHANAGAR"];
JilaTranslation["U. Kohlapur"] = JilaTranslation["UKohlapur"];
JilaTranslation["D. Kolhapur"] = JilaTranslation["DKolhapur"];
JilaTranslation["Met-Palayam"] = JilaTranslation["METPALAYAM"];
JilaTranslation["Puvanyun (Shahjipur Gramin"] = JilaTranslation["Puvanyun"];
JilaTranslation["Parshurampuri (Jalalabad)"] = JilaTranslation["Parshurampuri"];
JilaTranslation["Kumari(E)"] = JilaTranslation["Kumari_E"];
JilaTranslation["Kumari(W)"] = JilaTranslation["Kumari_W"];







JilaTranslation["Sambhajinagar Gramin"] = JilaTranslation["SambhajinagarGramin"];
JilaTranslation["Chikkamagaluru Grama"] = JilaTranslation["ChikkamagaluruGramantar"];
JilaTranslation["Mysuru Mahanagar"] = JilaTranslation["MysuruMahanagar"];
JilaTranslation["Mysuru Gramantar"] = JilaTranslation["MysuruGramantar"];
JilaTranslation["Bengaluru Gramantar"] = JilaTranslation["BengaluruGramantar"];
JilaTranslation["Warangal Gramin"] = JilaTranslation["WarangalGramin"];
JilaTranslation["Warangal Mahanagar"] = JilaTranslation["WarangalMahanagar"];
JilaTranslation["VISHAKA MAHANAGAR"] = JilaTranslation["VISHAKAMAHANAGAR"];
JilaTranslation["VIJAYAWADA MAHANAGAR"] = JilaTranslation["VIJAYAWADAMAHANAGAR"];
JilaTranslation["Thiruvananthapuram Gramam"] = JilaTranslation["THIRUVANANTHAPURAM_GRAMAM"];
JilaTranslation["Thiruvananthapuram Mahanagar"] = JilaTranslation["THIRUVANANTHAPURAM_MAHANAGAR"];
JilaTranslation["KOZHIKODE GRAMAM"] = JilaTranslation["KOZHIKODE_GRAMAM"];
JilaTranslation["Kozhikode Mahanagar"] = JilaTranslation["KOZHIKODE_MAHANAGAR"];
JilaTranslation["KOCHI MAHANAGAR"] = JilaTranslation["KOCHI_MAHANAGAR"];
JilaTranslation["Kollam Gramam"] = JilaTranslation["KOLLAM_GRAMAM"];
JilaTranslation["Kollam Mahanagar"] = JilaTranslation["KOLLAM_MAHANAGAR"];
JilaTranslation["Madurai Mahanagar"] = JilaTranslation["MADURAI_MAHANAGAR"];
JilaTranslation["Akola Mahanagar"] = JilaTranslation["AkolaMahanagar"];
JilaTranslation["Amrawati Mahanagar"] = JilaTranslation["AmrawatiMahanagar"];
JilaTranslation["Ujjain Gramin"] = JilaTranslation["UjjainGramin"];
JilaTranslation["Ujjain Mahanagar"] = JilaTranslation["UjjainMahanagar"];
JilaTranslation["Jabalapur Jila"] = JilaTranslation["JabalapurJila"];
JilaTranslation["Jabalapur Mahanagar"] = JilaTranslation["JabalapurMahanagar"];
JilaTranslation["Raipur Mahanagar"] = JilaTranslation["RaipurMahanagar"];
JilaTranslation["Raipur Gramin"] = JilaTranslation["RaipurGramin"];
JilaTranslation["Sanganer Gramin"] = JilaTranslation["SanganerGramin"];
JilaTranslation["Sanganer Mahanagar"] = JilaTranslation["SanganerMahanagar"];
JilaTranslation["Shree Madhopur"] = JilaTranslation["ShreeMadhopur"];
JilaTranslation["Jodhpur Mahanagar"] = JilaTranslation["JodhpurMahanagar"];
JilaTranslation["Bikaner Mahanagar"] = JilaTranslation["BikanerMahanagar"];
JilaTranslation["Shree Ganganagar"] = JilaTranslation["ShreeGanganagar"];
JilaTranslation["Udaipur Maha"] = JilaTranslation["UdaipurMaha"];
JilaTranslation["Udaipur Jila"] = JilaTranslation["UdaipurJila"];
JilaTranslation["Bhilwara Maha"] = JilaTranslation["BhilwaraMaha"];
JilaTranslation["Ajaymeru Maha"] = JilaTranslation["AjaymeruMaha"];
JilaTranslation["Kota Mahanagar"] = JilaTranslation["KotaMahanagar"];
JilaTranslation["Kota Jila"] = JilaTranslation["KotaJila"];
JilaTranslation["Gandhi Nagar"] = JilaTranslation["GandhiNagar"];
JilaTranslation["Mayur Vihar"] = JilaTranslation["MayurVihar"];
JilaTranslation["Saraswati Nagar"] = JilaTranslation["SaraswatiNagar"];
JilaTranslation["Mukhrjee Nagar"] = JilaTranslation["MukhrjeeNagar"];
JilaTranslation["Kamala Nagar"] = JilaTranslation["KamalaNagar"];
JilaTranslation["Karaul Baug"] = JilaTranslation["KaraulBaug"];
JilaTranslation["Patel Nagar"] = JilaTranslation["PatelNagar"];
JilaTranslation["Fatehgarh Sahib"] = JilaTranslation["FatehgarhSahib"];
JilaTranslation["Roop Nagar"] = JilaTranslation["RoopNagar"];
JilaTranslation["Faridabad Purva"]=JilaTranslation["FaridabadPurva"];
JilaTranslation["Faridabad Paschim"]=JilaTranslation["FaridabadPaschim"];
JilaTranslation["NOIDA Mahanagar"]=JilaTranslation["NoidaMahanagar"];
JilaTranslation["Vaishali Mahanagar"]=JilaTranslation["VaishaliMahanagar"];
JilaTranslation["Harnandi Mahanagar"]=JilaTranslation["HarnandiMahanagar"];
JilaTranslation["Gaziabad Jila"]=JilaTranslation["GaziabadJila"];
JilaTranslation["Lucknow - Poorva"]=JilaTranslation["LucknowPoorva"];
JilaTranslation["Lucknow - Pashchim"]=JilaTranslation["LucknowPashchim"];
JilaTranslation["Lucknow - Uttar"]=JilaTranslation["LucknowUttar"];
JilaTranslation["Lucknow - Dakshin"]=JilaTranslation["LucknowDakshin"];
JilaTranslation["Lucknow - Gramin"]=JilaTranslation["LucknowGramin"];
JilaTranslation["Kanpur Uttar"]=JilaTranslation["KanpurUttar"];
JilaTranslation["Kanpur Poorva"]=JilaTranslation["KanpurPoorva"];
JilaTranslation["Kanpur Dakshin"]=JilaTranslation["KanpurDakshin"];
JilaTranslation["Kanpur Pashchim"]=JilaTranslation["KanpurPashchim"];
JilaTranslation["Agra Paschim Mahanagar"]=JilaTranslation["AgraPaschimMahanagar"];
JilaTranslation["Agra Purv Mahanagar"]=JilaTranslation["AgraPurvMahanagar"];
JilaTranslation["Agra Chawani Mahanagar"]=JilaTranslation["AgraChawaniMahanagar"];
JilaTranslation["Jhansi Mahanagar"]=JilaTranslation["JhansiMahanagar"];
JilaTranslation["Jhansi Jila"]=JilaTranslation["JhansiJila"];
JilaTranslation["Urai Jila"]=JilaTranslation["UraiJila"];
JilaTranslation["Kanpur Dehat"]=JilaTranslation["KanpurDehat"];
JilaTranslation["Shrawasti Nagar"]=JilaTranslation["ShrawastiNagar"];
JilaTranslation["Maharaj Ganj"]=JilaTranslation["MaharajGanj"];
JilaTranslation["Gorakhpur Mahanagar Uttar"]=JilaTranslation["GorakhpurMahanagarUttar"];
JilaTranslation["Gorakhpur Mahanagar Dakshin"]=JilaTranslation["GorakhpurMahanagarDakshin"];
JilaTranslation["Gorakhpur Mahanagar Gramin"]=JilaTranslation["GorakhpurMahanagarGramin"];
JilaTranslation["Prayag Uttar"]=JilaTranslation["PrayagUttar"];
JilaTranslation["Prayag Dakshin"]=JilaTranslation["PrayagDakshin"];
JilaTranslation["Patana Mahanagar"]=JilaTranslation["PatanaMahanagar"];
JilaTranslation["Muzafarpur Mahanagar"]=JilaTranslation["MuzafarpurMahanagar"];
JilaTranslation["Muzafarpur Purvi Mahanagar"]=JilaTranslation["MuzafarpurPurviMahanagar"];
JilaTranslation["Muzafarpur Paschimi Mahanagar"]=JilaTranslation["MuzafarpurPaschimiMahanagar"];
JilaTranslation["Jamashedpur Mahanagar"]=JilaTranslation["JamashedpurMahanagar"];
JilaTranslation["Pashchim Sinhabhoom"]=JilaTranslation["PashchimSinhabhoom"];
JilaTranslation["Ranchi Mahanagar"] = JilaTranslation["RanchiMahanagar"];
JilaTranslation["Dhanabad Mahanagar"] = JilaTranslation["DhanabadMahanagar"];
JilaTranslation["Bokaro Mahanagar"] = JilaTranslation["BokaroMahanagar"];
JilaTranslation["Sambalpur Mahanagar"] = JilaTranslation["SambalpurMahanagar"];
JilaTranslation["Raurkela Mahanagar"] = JilaTranslation["RaurkelaMahanagar"];
JilaTranslation["Dakshin Andaman"] = JilaTranslation["DakshinAndaman"];
JilaTranslation["Madhya Andaman"] = JilaTranslation["MadhyaAndaman"];
JilaTranslation["Uttar Andaman"] = JilaTranslation["UttarAndaman"];
JilaTranslation["Dakshin Howrah"] = JilaTranslation["DakshinHowrah"];
JilaTranslation["Madhya Howrah"] = JilaTranslation["MaddhyaHowrah"];
JilaTranslation["Uttar Howrah"] = JilaTranslation["UttarHowrah"];
JilaTranslation["Uttar Paschim Howrah"] = JilaTranslation["UttarPaschimHowrah"];
JilaTranslation["Kolakata Uttar"] = JilaTranslation["Kolakatauttar"];
JilaTranslation["Kolakata Maddhya"] = JilaTranslation["KolakataMaddhya"];
JilaTranslation["Kolakata Pashchim"] = JilaTranslation["KolakataPashchim"];
JilaTranslation["Kolakata Poorw"] = JilaTranslation["KolakataPoorw"];
JilaTranslation["Kolakata Uttar Poorw"] = JilaTranslation["Kolakatauttarpoorw"];
JilaTranslation["Uttar Murshidabad"] = JilaTranslation["UttarMurshidabad"];
JilaTranslation["Dakshin Murshidabad"] = JilaTranslation["DakshinMurshidabad"];
JilaTranslation["Paschim Murshidabad"] = JilaTranslation["PaschimMurshidabad"];
JilaTranslation["Uttar Nadiya"] = JilaTranslation["UttarNadiya"];
JilaTranslation["Dakshin Nadiya"] = JilaTranslation["DokhinNadiya"];
JilaTranslation["Uttar Beerbhumi"] = JilaTranslation["UttarBeerbhumi"];
JilaTranslation["Dakshin Beerbhumi"] = JilaTranslation["DakshinBeerbhumi"];
JilaTranslation["Uttar Dinajpur"] = JilaTranslation["UttarDinajpur"];
JilaTranslation["Dakshin Dinajpur"] = JilaTranslation["DaxinDinajpur"];
JilaTranslation["Uttar Malda"] = JilaTranslation["UttarMalda"];
JilaTranslation["Uttar Mursidabad"] = JilaTranslation["UttarMursidabad"];
JilaTranslation["Dakshin Kachad"] = JilaTranslation["DakshinKachad"];
JilaTranslation["Madhya Kachad"] = JilaTranslation["MadhyaKachad"];
JilaTranslation["Paschim Kachad"] = JilaTranslation["PaschimKachad"];
JilaTranslation["East Khasi Hills"] = JilaTranslation["EastKhasiHills"];
JilaTranslation["West Khasi Hills"] = JilaTranslation["WestKhasiHills"];
JilaTranslation["East Garo Pahad"] = JilaTranslation["EastGaroPahad"];
JilaTranslation["South west Garo Pahad"] = JilaTranslation["SouthwestGaroPahad"];
JilaTranslation["North west Garo Pahad"] = JilaTranslation["NorthwestGaroPahad"];
JilaTranslation["Uttar Nagbhumi"] = JilaTranslation["UttarNagbhumi"];
JilaTranslation["Dakshin Nagbhumi"] = JilaTranslation["DakshinNagbhumi"];
JilaTranslation["Uttar Tripura"] = JilaTranslation["UttarTripura"];
JilaTranslation["Paschim Tripura"] = JilaTranslation["PaschimTripura"];
JilaTranslation["Dakshin Tripura"] = JilaTranslation["DakshinTripura"];
JilaTranslation["hubballi mahanagar"] = JilaTranslation["HUBBALLIMAHANAGAR"];
JilaTranslation["SRI SATYASAI"] = JilaTranslation["SRISATYASAI"];
JilaTranslation["EAST GODAVARI"] = JilaTranslation["EASTGODAVARI"];
JilaTranslation["WEST GODAVARI"] = JilaTranslation["WESTGODAVARI"];
JilaTranslation["WEST GODAVARI"] = JilaTranslation["WESTGODAVARI"];







export {JilaTranslation,VibhagTranslation,PrantTranslation,kshetraTranslation,KendraTranslation}